// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:39:15.824Z
// Property: Center 301 (ID: 6767906449165590)
// Collections: 24 amenities, 9 floorplans (live), 53 photos, 67 POIs, 1 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165590",
  "property_external_id": "2zryysb",
  "property_zillow_url": "https://www.zillow.com/apartments/belton-mo/center-301/CjfRnC/",
  "property_apartments_url": "https://www.apartments.com/center-301-belton-mo/2zryysb/",
  "property_google_business_url": "https://www.google.com/maps/place/Center+301+Apartments/data=!4m2!3m1!1s0x0:0x327cbbaac415debc?sa=X&ved=2ahUKEwjMwczS87ySAxUTF7kGHXXMKvEQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "center-301",
  "property_name": "Center 301",
  "property_website_url": "https://www.caseusa.com/apartments/mo/belton/center-301/",
  "property_domain": null,
  "property_address": "301 Towne Center Drive",
  "property_full_address": "301 Towne Center Drive, Belton, Belton, 64012",
  "property_address_1": "301 Towne Center Drive",
  "property_address_2": null,
  "property_address_city": "Belton",
  "property_address_state": "Missouri",
  "property_address_zip_full": null,
  "property_address_zip": "64012",
  "property_address_country": "US",
  "property_address_county": "Cass County",
  "property_neighborhood_address": "https://www.caseusa.com/apartments/mo/belton/center-301/",
  "property_address_latitude": "38.81815",
  "property_address_longitude": "-94.51633",
  "property_email": "Center301@caseusa.com",
  "property_phone": "(833) 685-6030",
  "property_call_tracking_phone": "833-685-6030",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Center 301 in Belton, Missouri, where luxurious living meets vibrant community life. Choose from spacious one and two-bedroom floor plans, each featuring modern amenities like stainless steel appliances, walk-in closets, and private patios. Unwind by the pool, work out in our fitness center, or enjoy a picnic near the scenic trails. Your perfect home awaits! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Center 301, your dream apartment community located in the heart of Belton, Missouri! Offering a diverse range of floor plans, including spacious one and two-bedroom apartments, Center 301 is designed to accommodate your lifestyle while providing modern comfort and convenience.\n\nStep outside your door and discover a wealth of luxurious amenities at your fingertips. Dive into relaxation at our inviting pool, or maintain your fitness routine in our state-of-the-art fitness center. Our stylish clubhouse is perfect for social gatherings, while the business center supports your professional needs with 24-hour access to online services. Enjoy peace of mind with a dedicated property manager on site and secure, gated access.\n\nFurry friends are welcome too! Our pet play area ensures your pets have as much fun as you do. Start your mornings right with our complimentary breakfast/coffee concierge, and unwind in the picnic area or by the grill on a sunny afternoon.\n\nEach apartment features high-end finishes and thoughtful touches such as walk-in closets, stainless steel appliances, and vaulted ceilings. Enjoy the ease of in-unit washer/dryer hookups, a cozy fireplace, and private balconies or patios perfect for enjoying the beautiful Belton landscape.\n\nExplore walking and biking trails right outside your door, as life at Center 301 blends suburban tranquility with modern amenities. Don’t miss your opportunity to experience this vibrant community!\n\nFind your new home today—browse our availability or schedule a tour to visit Center 301 and see all that we have to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019fb44b-351f-745b-9623-0aff53fd603b.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and cabana.",
    "public_id": "019fb44b-351f-745b-9623-0aff53fd603b",
    "storage_key": "property/6767906449165590/019fb44b-351f-745b-9623-0aff53fd603b.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "306",
  "property_year_built": "2022",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum 2 pets per unit. Weight limit: 80 lb per pet. Breed restrictions apply; service animals excluded.",
  "property_pet_policy_description": "We welcome cats and dogs up to 80 lb each. Pet fee: $500 (non‑refundable) per pet. Monthly pet rent: $30 per pet. Maximum 2 pets per unit. Service animals are not considered pets and are excluded.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://center301apartmentsbelton.securecafe.com/onlineleasing/center-301/floorplans.aspx",
  "property_resident_portal_url": "https://center301apartmentsbelton.securecafe.com/residentservices/center-301/userlogin.aspx",
  "property_apply_now_url": "https://center301apartmentsbelton.securecafe.com/onlineleasing/center-301/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3a-c898-729e-a8a0-c29afa67298d.webp",
  "property_primary_logo_media": {
    "alt_text": "Center Apartments 301 logo.",
    "public_id": "019cfb3a-c898-729e-a8a0-c29afa67298d",
    "storage_key": "property/6767906449165590/019cfb3a-c898-729e-a8a0-c29afa67298d.webp",
    "width": 1007,
    "height": 282
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3c-1a62-7261-a7bd-b888f62d0edb.webp",
  "property_secondary_logo_media": {
    "alt_text": "C/301 logo",
    "public_id": "019cfb3c-1a62-7261-a7bd-b888f62d0edb",
    "storage_key": "property/6767906449165590/019cfb3c-1a62-7261-a7bd-b888f62d0edb.webp",
    "width": 440,
    "height": 281
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3c-2965-7326-b050-71e8d730da4a.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Center Apartments 301 logo",
    "public_id": "019cfb3c-2965-7326-b050-71e8d730da4a",
    "storage_key": "property/6767906449165590/019cfb3c-2965-7326-b050-71e8d730da4a.webp",
    "width": 640,
    "height": 179
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3c-314d-769b-ba9b-6b0b5565645c.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Center Apartments 301 logo",
    "public_id": "019cfb3c-314d-769b-ba9b-6b0b5565645c",
    "storage_key": "property/6767906449165590/019cfb3c-314d-769b-ba9b-6b0b5565645c.webp",
    "width": 640,
    "height": 179
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#ffb548",
  "property_secondary_color": "#324d58",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#5e5e5e",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1350",
  "property_sqft_min": "789",
  "property_sqft_max": "1350",
  "property_price_range": "1294 - 1779",
  "property_price_min": "1294",
  "property_price_max": "1779",
  "property_available_units": 17,
  "property_facebook_url": "https://www.facebook.com/Center301Apts/posts/855609070614161/",
  "property_instagram_url": "https://www.instagram.com/center_301_apartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJW6mPDTbdwIcRvN4VxKq7fDI",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/center-301-apartments-belton",
  "property_tiktok_url": "https://www.tiktok.com/@center301apartments?_t=8lPkguT8exq&_r=1",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Center 301",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "Welcome to Center 301 in Belton, Missouri, where modern living meets comfort. Choose from spacious one or two-bedroom floor plans designed for your lifestyle. Enjoy a refreshing pool, a state-of-the-art fitness center, and inviting picnic areas—all within a gated community. Experience unmatched amenities and style right at your doorstep!",
  "property_home_floorplans_blurb": "Welcome to Center 301 in Belton, Missouri, where comfort meets style. Choose the ideal living space from our thoughtfully designed one and two-bedroom apartments. With unique layouts and modern finishes, there’s a perfect home waiting for you. Browse our available options today and step into your new life!",
  "property_home_gallery_blurb": "At Center 301 in Belton, Missouri, where convenience meets comfort, imagine unwinding by the pool or hosting friends in a modern clubhouse. With spacious one and two-bedroom floor plans and amenities like a state-of-the-art fitness center, picnic area, and gated access, your ideal lifestyle awaits. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At Center 301, your ideal Belton lifestyle awaits, featuring spacious one and two-bedroom floor plans. Enjoy the perfect blend of convenience and charm with local favorites like Mid-Continent Public Library, Southwick Stadium, and beautiful parks. Embrace community living, where everything you need is just a heartbeat away.",
  "property_home_reviews_blurb": "Welcome to Center 301, where our residents rave about the exceptional maintenance team and stunning living spaces! With clean, spacious apartments and friendly staff eager to assist, you’ll feel right at home. Experience the quality construction and inviting atmosphere that make our community truly special. Join us in Belton, Missouri!",
  "property_neighborhood_blurb": "At Center 301 in Belton, Missouri, vibrant living meets convenient access to local gems. Enjoy nearby attractions like the Belton Museum, Mid-Continent Public Library, and beautiful parks such as Hawk Ridge and Meadowmere. Embrace a lifestyle where entertainment, education, and recreation seamlessly blend just outside your door.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Center 301 in Belton, Missouri, indulge in a lifestyle that combines comfort and luxury. Enjoy our sparkling pool, state-of-the-art fitness center, and inviting clubhouse. Elevate your living with spacious floor plans and modern amenities like stainless steel appliances, walk-in closets, and charming outdoor spaces. Join us today!",
  "property_applynow_blurb": "At Center 301 in Belton, Missouri, your perfect home awaits with spacious one- and two-bedroom floor plans. Enjoy resort-style amenities like a sparkling pool, modern fitness center, and inviting picnic area. Experience the convenience of 24-hour services and pet-friendly spaces. Lease online today and elevate your lifestyle!",
  "property_contactus_blurb": "At Center 301 in Belton, Missouri, your ideal living space awaits. Choose from our thoughtfully designed one- and two-bedroom floor plans, perfectly tailored to fit your lifestyle. Have questions? Our friendly leasing team is just a message away, ready to help you find your perfect home!",
  "property_faqs_blurb": "Welcome to Center 301 in Belton, Missouri, where your ideal living space awaits! From cozy one-bedroom layouts to spacious two-bedroom designs, our community offers a variety of floor plans. Find clarity on your questions by visiting our FAQs page, ensuring you feel confident in your home choice.",
  "property_floorplans_blurb": "At Center 301 in Belton, Missouri, our thoughtfully designed floor plans cater to every lifestyle. Choose from spacious one-bedroom havens or generous two-bedroom retreats, each built for comfort and style. Browse our available apartment homes today and uncover the ideal living space that suits your needs perfectly.",
  "property_gallery_blurb": "At Center 301 in Belton, Missouri, indulge in a vibrant lifestyle enhanced by luxurious one and two-bedroom floor plans. Picture yourself lounging by the pool, enjoying a coffee from our concierge, or unwinding on your private balcony. Elevate your living experience amid breathtaking amenities and scenic walking trails!",
  "property_interactivemap_blurb": "At Center 301 in Belton, Missouri, your perfect home awaits! Choose from spacious one- or two-bedroom floor plans, complete with modern amenities like a resort-style pool, a state-of-the-art fitness center, and a welcoming clubhouse. Dive into comfort and convenience—explore our interactive community map today to find your dream apartment!",
  "property_pets_blurb": "At Center 301 in Belton, Missouri, your furry friends can feel right at home. With a spacious layout, our pet-friendly community welcomes up to two cats or dogs per apartment, fostering a lively atmosphere. Enjoy stylish living with ample room for both you and your pets to thrive!",
  "property_referafriend_blurb": "At Center 301 in Belton, Missouri, your ideal home awaits with stylish one and two-bedroom floor plans. Share the joy of vibrant living with friends—when you refer someone, you’re not just connecting them to a home, but to a community. Great friends make great neighbors; start your journey today!",
  "property_residentaccess_blurb": "Welcome to Center 301 in Belton, Missouri, where your ideal living space awaits! Choose from our stylish one or two-bedroom floor plans tailored for comfort and convenience. Log into your resident portal now to seamlessly pay rent, schedule maintenance, and enjoy a worry-free lifestyle. Your home experience starts here!",
  "property_reviews_blurb": "At Center 301 in Belton, Missouri, residents rave about our exceptional team and welcoming atmosphere. With quick response times and committed staff, one resident exclaims, \"I am beyond impressed and will always give praise.\" Experience spacious, clean apartments and discover why our community is the right choice for you!",
  "property_created_at": "1753982379282",
  "property_scheduletour_blurb": "At Center 301 in Belton, Missouri, your ideal living space awaits with thoughtfully designed one and two-bedroom floor plans. Immerse yourself in a vibrant community atmosphere where residents share their experiences and joys of living here. Schedule a tour today—let your new home story begin!",
  "property_thankyou_blurb": "Thank you for reaching out to Center 301 in Belton, Missouri! Your interest brings you closer to our stylish one and two-bedroom floor plans, designed for comfort and convenience. Our team will be in touch shortly to assist you in finding your perfect home. Stay tuned for exciting updates!",
  "property_virtualtours_blurb": "Experience modern living at Center 301 in Belton, Missouri. Our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Enjoy spacious interiors and resort-style amenities. Dive into a virtual tour today and imagine your new home—a place where comfort meets convenience. Your perfect apartment awaits!",
  "property_copyright": "2025 All Rights Reserved. Center 301",
  "property_seo_title_home": "Center 301 |  Apartments in Belton, Missouri",
  "property_seo_description_home": "Experience modern living at Center 301 in Belton, MO! Enjoy stylish floor plans, a pool, fitness center, and pet-friendly amenities. Your ideal home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Belton, Missouri Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Center 301 in Belton, MO! Choose from stylish one and two-bedroom floor plans tailored for comfort. Your perfect home awaits!",
  "property_seo_title_amenities": "Amenities | Belton, Missouri Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Center 301 in Belton, MO! From a refreshing pool to a vibrant clubhouse, our amenities cater to your every need. Join us today!",
  "property_seo_title_gallery": "Gallery | Apartments in Belton, Missouri",
  "property_seo_description_gallery": "Experience life at Center 301 in Belton, MO! Immerse in amenities like a pool, fitness center, and pet-friendly trails. Imagine calling this home!",
  "property_seo_title_virtualtours": "Virtual Tours | Center 301 Apartments",
  "property_seo_description_virtualtours": "Experience life at Center 301 in Belton, MO! Take a virtual tour of our stylish one & two-bedroom apartments designed for comfort and creativity.",
  "property_seo_title_interactivemap": "Interactive Map | Center 301 Apartments",
  "property_seo_description_interactivemap": "Find your perfect apartment at Center 301 in Belton, MO! Check our interactive map for floor plans, amenities, and pricing. Live your best life today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Belton, Missouri",
  "property_seo_description_neighborhood": "Experience the charm of Belton, Missouri at Center 301. Explore neighborhood gems, local favorites, and vibrant attractions just steps from your doorstep!",
  "property_seo_title_contact": "Contact Us | Center 301",
  "property_seo_description_contact": "Connect with Center 301 in Belton, MO! Inquire about our one- and two-bedroom plans and let our leasing team help you find your perfect home.",
  "property_seo_title_faqs": "FAQs | Apartments in Belton, Missouri",
  "property_seo_description_faqs": "Get answers about Center 301 in Belton, MO! Our FAQs cover amenities, leasing info, and more to elevate your living experience.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Belton, Missouri",
  "property_seo_description_reviews": "Join the vibrant community at Center 301 in Belton, MO! Discover top-notch amenities and spacious floor plans. Your new home awaits!",
  "property_seo_title_applynow": "Apply Now | Apartments in Belton, Missouri",
  "property_seo_description_applynow": "Experience luxury living at Center 301 in Belton, MO! Enjoy spacious apartments with top-notch amenities, a pool, and scenic trails. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Center 301",
  "property_seo_description_residentaccess": "Elevate your living at Center 301 in Belton, MO. Log in to your resident portal for rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Center 301",
  "property_seo_description_referafriend": "Refer a friend to Center 301 in Belton, MO—where great friendships blossom and every neighbor feels like family. Join us today for a vibrant community!",
  "property_seo_title_scheduletour": "Schedule a Tour | Center 301",
  "property_seo_description_scheduletour": "Experience modern living at Center 301 in Belton, MO! Schedule your tour today and see why our vibrant community is the perfect place to call home.",
  "property_seo_title_privacy": "Privacy Policy | Center 301",
  "property_seo_description_privacy": "Your privacy matters at Center 301 in Belton, MO. Learn how we protect your information and create a secure community. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Center 301",
  "property_seo_description_accessibility": "Experience true digital inclusion at Center 301 in Belton, MO. Our commitment to accessibility ensures everyone can enjoy modern living at its best.",
  "property_seo_title_sitemap": "Sitemap | Center 301",
  "property_seo_description_sitemap": "Navigate your way through Center 301 in Belton, MO! Check our sitemap for a user-friendly guide to explore our community's amenities and offerings.",
  "property_seo_title_thankyou": "Thank You | Center 301",
  "property_seo_description_thankyou": "Thank you for reaching out to Center 301! Your inquiry is important to us. We’ll be in touch soon to help you find your perfect home in Belton, Missouri.",
  "property_seo_title_pets": "Pet Policy | Apartments in Belton, Missouri",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787864934105",
  "amenities": [
    {
      "id": "ec_365ae7606ef157ad2816cbe1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127396310",
      "title": "Media Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ec395c1ca1913b226f6e427",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127396312",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1401d53db7b3754e0a57464b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127396314",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0d5302469b9897b7c24d482",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127396316",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f43592673ea885129a26e1c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127396317",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_193042d67342d4fd7fcd0355",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127396318",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69fa48a27fa52299da38f57b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127396319",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_46c46bd8a47e92b8e4b6dc70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127396320",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_160643379b2e4c21dd6708c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127396321",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb9ad922f77fc417d8722470",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "128017315",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9633f6929133e2e652156dd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127397821",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a3e8e26597467f33a0a19d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127397822",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76a6631c630646584165d470",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127397823",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_59b300e6e0244623cf5acdec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127397824",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4311844dc0aa44ee5921c8b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127397825",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25b7f88fa8213c57a3ec641a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127397826",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8b1d99f29057aa5fe8a9785",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127397827",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_75e8adad9b568f310dfd2073",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127397828",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cd0b5080ea1f7caa8f762e36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127397829",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f72ce79263f88c84b1f0ce35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127397830",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56646f878453221d458347ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127397831",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc21434aa8516ecc90a9a848",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127397832",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ecce9dc53491c850909ca6ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127397833",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_433120b9bf4ca1cce5c66f19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "yardi",
      "external_id": "127397834",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_fcf2b8c3-6030-418f-962a-30533c139a05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f4320-3130-770c-82d3-3fc008c5274a.webp",
      "image_media": {
        "alt_text": "Desk and dining area with blue accents in an apartment.",
        "public_id": "019f4320-3130-770c-82d3-3fc008c5274a",
        "storage_key": "property/6767906449165590/019f4320-3130-770c-82d3-3fc008c5274a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Stylish apartment living with a dedicated workspace and elegant dining area, featuring chic blue curtains and modern decor.",
      "link": "",
      "alt_text": "Desk and dining area with blue accents in an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_73797146-c0d9-4337-a7c0-31f3820af8c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f4320-30ef-72da-838d-48f3379af8ec.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstand, dresser, and ceiling fan.",
        "public_id": "019f4320-30ef-72da-838d-48f3379af8ec",
        "storage_key": "property/6767906449165590/019f4320-30ef-72da-838d-48f3379af8ec.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and beautifully furnished bedroom featuring a comfortable king-size bed, a modern nightstand with a lamp, and a wooden dresser. The room is enhanced by a ceiling fan and large windows.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstand, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4393ceea-78b5-4fe4-a211-e69343abf74a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f4320-33ff-73b7-81dd-953c0414d3c5.webp",
      "image_media": {
        "alt_text": "Dining room with a table and chairs, large windows with blue curtains.",
        "public_id": "019f4320-33ff-73b7-81dd-953c0414d3c5",
        "storage_key": "property/6767906449165590/019f4320-33ff-73b7-81dd-953c0414d3c5.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy meals with family and friends in this spacious dining room, featuring a large table, comfortable chairs, and abundant natural light from the large windows.",
      "link": "",
      "alt_text": "Dining room with a table and chairs, large windows with blue curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_018e3f1d-55dc-4172-a47c-0b58498158b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f4320-251c-778e-806d-a4e40ca52b77.webp",
      "image_media": {
        "alt_text": "Modern living room with a large sofa, coffee table, and TV.",
        "public_id": "019f4320-251c-778e-806d-a4e40ca52b77",
        "storage_key": "property/6767906449165590/019f4320-251c-778e-806d-a4e40ca52b77.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in style in this beautifully appointed living room, featuring comfortable seating and a large flat-screen TV for entertainment.",
      "link": "",
      "alt_text": "Modern living room with a large sofa, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_27ade525-454b-49bf-b853-08e81c3f791e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f4320-0eb8-75b3-8a8c-bdc310f37675.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sectional sofa, coffee table, desk area, and large windows.",
        "public_id": "019f4320-0eb8-75b3-8a8c-bdc310f37675",
        "storage_key": "property/6767906449165590/019f4320-0eb8-75b3-8a8c-bdc310f37675.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed living room, featuring a plush sectional sofa, a stylish coffee table, and a dedicated workspace. Large windows flood the space with natural light, offering serene views.",
      "link": "",
      "alt_text": "Spacious living room with a sectional sofa, coffee table, desk area, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0d9b5181-c286-42ab-a940-3cb110dbe266",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f4320-0c1b-70b1-bf1a-fad972095127.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and white countertops.",
        "public_id": "019f4320-0c1b-70b1-bf1a-fad972095127",
        "storage_key": "property/6767906449165590/019f4320-0c1b-70b1-bf1a-fad972095127.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, and bright countertops, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and white countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_230c2396-6fc7-4d2f-af45-63b98ac938dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f4320-0a24-750c-b841-90528b06c39f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a double vanity, large mirror, and a blue shower curtain.",
        "public_id": "019f4320-0a24-750c-b841-90528b06c39f",
        "storage_key": "property/6767906449165590/019f4320-0a24-750c-b841-90528b06c39f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Step into this stylish bathroom featuring a spacious double vanity with ample storage, a large mirror, and a soothing blue shower curtain for a spa-like feel.",
      "link": "",
      "alt_text": "Modern bathroom with a double vanity, large mirror, and a blue shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_13d091eb-2ffe-4fe2-9c3b-6ce725769108",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f4320-0bf5-76a9-b332-4ec859b32cf1.webp",
      "image_media": {
        "alt_text": "A laundry room featuring a pet bowl, basket of towels, and decorative art.",
        "public_id": "019f4320-0bf5-76a9-b332-4ec859b32cf1",
        "storage_key": "property/6767906449165590/019f4320-0bf5-76a9-b332-4ec859b32cf1.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Spacious laundry room with decorative art, a pet bowl, and a basket of towels. Enjoy the convenience of in-unit laundry.",
      "link": "",
      "alt_text": "A laundry room featuring a pet bowl, basket of towels, and decorative art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6d3ad0fa-bdc6-422b-93e7-773f629e84eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f4320-0b51-76e8-b223-7c63775e71c3.webp",
      "image_media": {
        "alt_text": "A beautifully decorated bedroom with a large tufted headboard bed, blue curtains, and a ceiling fan.",
        "public_id": "019f4320-0b51-76e8-b223-7c63775e71c3",
        "storage_key": "property/6767906449165590/019f4320-0b51-76e8-b223-7c63775e71c3.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this inviting bedroom, featuring a plush bed and ample natural light. Perfect for relaxation.",
      "link": "",
      "alt_text": "A beautifully decorated bedroom with a large tufted headboard bed, blue curtains, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d04b6664-2937-43d0-b37b-f0ca5648f787",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f4320-14be-708f-9d17-ed5d63943175.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and marble countertops.",
        "public_id": "019f4320-14be-708f-9d17-ed5d63943175",
        "storage_key": "property/6767906449165590/019f4320-14be-708f-9d17-ed5d63943175.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring stainless steel appliances, ample cabinet space, and elegant marble countertops, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f7b712c3-2275-43cf-8c0a-59cbda32a131",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f4320-0a62-7794-a608-6b9a2f81dca5.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and shower curtain.",
        "public_id": "019f4320-0a62-7794-a608-6b9a2f81dca5",
        "storage_key": "property/6767906449165590/019f4320-0a62-7794-a608-6b9a2f81dca5.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Step into this bright and airy bathroom, featuring a spacious vanity, modern fixtures, and a stylish shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_def07f61-c381-49be-a665-d89c51ade1ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f4320-0d8a-74c2-9c8b-8c9e2ac2745b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a marble countertop.",
        "public_id": "019f4320-0d8a-74c2-9c8b-8c9e2ac2745b",
        "storage_key": "property/6767906449165590/019f4320-0d8a-74c2-9c8b-8c9e2ac2745b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A spacious and updated kitchen featuring stainless steel appliances, ample cabinet storage, and a sleek marble countertop. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a marble countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c726ac3d-f05b-478d-91a1-8e5fc3512a89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-9706-75d8-8454-b00c7fb3af2b.webp",
      "image_media": {
        "alt_text": "Living and dining area of a modern apartment, featuring a couch, coffee table, dining set, and large windows.",
        "public_id": "019f431f-9706-75d8-8454-b00c7fb3af2b",
        "storage_key": "property/6767906449165590/019f431f-9706-75d8-8454-b00c7fb3af2b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living and dining area in a modern apartment, perfect for relaxation and entertaining. Features a stylish couch, coffee table, and dining set, with ample natural light from large windows.",
      "link": "",
      "alt_text": "Living and dining area of a modern apartment, featuring a couch, coffee table, dining set, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0b4094be-5820-4174-a4b3-6af17de6373a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-949b-741e-8266-ef1acfd73002.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and a marble island with bar stools.",
        "public_id": "019f431f-949b-741e-8266-ef1acfd73002",
        "storage_key": "property/6767906449165590/019f431f-949b-741e-8266-ef1acfd73002.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring stainless steel appliances, ample cabinet space, and a breakfast bar perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and a marble island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7954f9ac-def6-43e1-9e8f-71fc4dfe25bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-a63c-71ac-a73b-ae6d2b9b0e3c.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and ceiling fan.",
        "public_id": "019f431f-a63c-71ac-a73b-ae6d2b9b0e3c",
        "storage_key": "property/6767906449165590/019f431f-a63c-71ac-a73b-ae6d2b9b0e3c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed with decorative pillows, a large dresser with a mirror, and a modern ceiling fan for comfort.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_18684f39-3c6b-49f4-b549-d536f518e969",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-9cbf-750c-9476-de9ed20ba09f.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, sofa, and coffee table.",
        "public_id": "019f431f-9cbf-750c-9476-de9ed20ba09f",
        "storage_key": "property/6767906449165590/019f431f-9cbf-750c-9476-de9ed20ba09f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace, comfortable seating, and large windows with scenic views.",
      "link": "",
      "alt_text": "Living room with fireplace, sofa, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ce12141b-befd-468c-b71f-282cf5e7024e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-a0b9-723e-b999-7950d034cf30.webp",
      "image_media": {
        "alt_text": "Dining room with a table set for four, featuring artwork and a balcony view.",
        "public_id": "019f431f-a0b9-723e-b999-7950d034cf30",
        "storage_key": "property/6767906449165590/019f431f-a0b9-723e-b999-7950d034cf30.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy meals with family and friends in this elegant dining area, perfect for intimate dinners or casual gatherings.",
      "link": "",
      "alt_text": "Dining room with a table set for four, featuring artwork and a balcony view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1d778881-d424-446f-9054-9b0979f23933",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-a565-71dc-8d3e-3fb10b4c6b6d.webp",
      "image_media": {
        "alt_text": "View of the community grounds and buildings from a balcony.",
        "public_id": "019f431f-a565-71dc-8d3e-3fb10b4c6b6d",
        "storage_key": "property/6767906449165590/019f431f-a565-71dc-8d3e-3fb10b4c6b6d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy the outdoors from your private balcony overlooking the community grounds and buildings.",
      "link": "",
      "alt_text": "View of the community grounds and buildings from a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cd9f6434-de51-4a71-bcb0-70262c1554f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-a0b2-74c8-91f6-c2155d4ce617.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace and a bar area with stools leading to the kitchen.",
        "public_id": "019f431f-a0b2-74c8-91f6-c2155d4ce617",
        "storage_key": "property/6767906449165590/019f431f-a0b2-74c8-91f6-c2155d4ce617.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy a cozy evening by the fireplace in this stylish living area, perfect for entertaining or relaxing, with a convenient bar and kitchen accessible.",
      "link": "",
      "alt_text": "Living room with a fireplace and a bar area with stools leading to the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_19b2fa00-f9b3-4da6-93db-7333e60e0194",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-8377-75ac-b72f-613edcafd9d6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a marble island. Open to a living area.",
        "public_id": "019f431f-8377-75ac-b72f-613edcafd9d6",
        "storage_key": "property/6767906449165590/019f431f-8377-75ac-b72f-613edcafd9d6.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark wood cabinetry, stainless steel appliances, and a stylish marble island. This open-concept layout flows seamlessly into a comfortable living area.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a marble island. Open to a living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6b60cb86-e432-471e-8652-0741ed4af977",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-868a-769c-9100-4a7886fb87f5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and marble countertops.",
        "public_id": "019f431f-868a-769c-9100-4a7886fb87f5",
        "storage_key": "property/6767906449165590/019f431f-868a-769c-9100-4a7886fb87f5.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and updated kitchen featuring stainless steel appliances, ample cabinet space, and elegant marble countertops.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_734d46ad-7e18-41bd-a170-dd16a7ba2e41",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-5ad5-775d-9108-6250e2cf0661.webp",
      "image_media": {
        "alt_text": "Living room and dining area in an apartment with a green sofa, armchair, and dining table.",
        "public_id": "019f431f-5ad5-775d-9108-6250e2cf0661",
        "storage_key": "property/6767906449165590/019f431f-5ad5-775d-9108-6250e2cf0661.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a plush green sofa, a cozy armchair, and a stylish dining set. Perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Living room and dining area in an apartment with a green sofa, armchair, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2be80dc1-5a01-4335-a9c7-14b923b2bb9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-7567-72c1-988a-699a25b89de8.webp",
      "image_media": {
        "alt_text": "View from a balcony overlooking a swimming pool and apartment buildings.",
        "public_id": "019f431f-7567-72c1-988a-699a25b89de8",
        "storage_key": "property/6767906449165590/019f431f-7567-72c1-988a-699a25b89de8.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy resort-style living with a beautiful outdoor swimming pool and lush green spaces, all visible from your private balcony.",
      "link": "",
      "alt_text": "View from a balcony overlooking a swimming pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_58a97028-002d-4405-afa8-7446a23fc784",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-7d1e-74dc-afc2-601967517c0f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with dark vanity, marble countertop, and black accents.",
        "public_id": "019f431f-7d1e-74dc-afc2-601967517c0f",
        "storage_key": "property/6767906449165590/019f431f-7d1e-74dc-afc2-601967517c0f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a spacious vanity with ample storage, a sleek marble countertop, and stylish black fixtures, complemented by a patterned floor and a striped shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with dark vanity, marble countertop, and black accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e5e9ccb0-401f-4a3f-b123-77fc6261121c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-6a06-76d8-aa48-b05294c9934f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019f431f-6a06-76d8-aa48-b05294c9934f",
        "storage_key": "property/6767906449165590/019f431f-6a06-76d8-aa48-b05294c9934f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring dark wood cabinetry, granite countertops, and stainless steel appliances. Perfect for home chefs and everyday convenience.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_23fb7466-2ccc-4532-a655-5299cb565dcc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-7584-7782-99f7-50dd048e6f7b.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and dresser. Modern decor with neutral tones.",
        "public_id": "019f431f-7584-7782-99f7-50dd048e6f7b",
        "storage_key": "property/6767906449165590/019f431f-7584-7782-99f7-50dd048e6f7b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and well-appointed bedroom featuring a comfortable queen-size bed, stylish nightstands, and ample storage. Perfect for relaxation and rest.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and dresser. Modern decor with neutral tones.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cc92f97b-e2b7-48d2-b1e5-d20f78116deb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-6d25-72cf-b4af-a3f3736e85d6.webp",
      "image_media": {
        "alt_text": "Round dining table with four white chairs in a dining area with a large abstract painting and a balcony door.",
        "public_id": "019f431f-6d25-72cf-b4af-a3f3736e85d6",
        "storage_key": "property/6767906449165590/019f431f-6d25-72cf-b4af-a3f3736e85d6.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A stylish dining area featuring a round wooden table set with four white chairs, complemented by a large abstract painting on the wall and access to a balcony.",
      "link": "",
      "alt_text": "Round dining table with four white chairs in a dining area with a large abstract painting and a balcony door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_90bbd077-8f78-4563-aa3b-20c2681a1f66",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-6115-723b-a4fa-ca978489ebb9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
        "public_id": "019f431f-6115-723b-a4fa-ca978489ebb9",
        "storage_key": "property/6767906449165590/019f431f-6115-723b-a4fa-ca978489ebb9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet storage, and a large island perfect for casual dining or entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_175d78fb-030c-48f3-a324-42ff9f71acf4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-3ac2-71cf-834d-8bf91f0f79c3.webp",
      "image_media": {
        "alt_text": "Desk and dining area in a well-lit apartment living space.",
        "public_id": "019f431f-3ac2-71cf-834d-8bf91f0f79c3",
        "storage_key": "property/6767906449165590/019f431f-3ac2-71cf-834d-8bf91f0f79c3.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Create a productive and elegant living space with this stylish desk and dining area, perfect for work or meals.",
      "link": "",
      "alt_text": "Desk and dining area in a well-lit apartment living space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_def25cfb-b596-4405-958a-a66f25143f23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-3748-73ed-8754-4a60dcdeb0bd.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen with island seating, sofa, and desk.",
        "public_id": "019f431f-3748-73ed-8754-4a60dcdeb0bd",
        "storage_key": "property/6767906449165590/019f431f-3748-73ed-8754-4a60dcdeb0bd.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and bright apartment featuring an open-concept living area and a modern kitchen with an island and bar stools.",
      "link": "",
      "alt_text": "Modern living room and kitchen with island seating, sofa, and desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_08d7e23a-a9e5-4a6f-b9ef-8fe81e89ecf5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-3cd4-7756-bd5a-41b17e63262a.webp",
      "image_media": {
        "alt_text": "Dining area with a round wooden table and four chairs by large windows with macrame curtains.",
        "public_id": "019f431f-3cd4-7756-bd5a-41b17e63262a",
        "storage_key": "property/6767906449165590/019f431f-3cd4-7756-bd5a-41b17e63262a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy meals in this bright dining area, featuring a round table and four chairs, complemented by large windows and decorative macrame curtains.",
      "link": "",
      "alt_text": "Dining area with a round wooden table and four chairs by large windows with macrame curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_12687c6e-3d09-45dc-b10b-7508be488f9c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431f-3b62-759c-b636-27f34089c9fb.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, plush bedding, and a ceiling fan.",
        "public_id": "019f431f-3b62-759c-b636-27f34089c9fb",
        "storage_key": "property/6767906449165590/019f431f-3b62-759c-b636-27f34089c9fb.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in our spacious bedrooms, featuring elegant furnishings and a serene ambiance.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, plush bedding, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ee0aeefd-536d-42f4-8986-e24fb5e9fe8b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-c5c8-719b-a4cb-97f7ea0cd79c.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park area with play structures, a bench, and apartment buildings in the background.",
        "public_id": "019f431e-c5c8-719b-a4cb-97f7ea0cd79c",
        "storage_key": "property/6767906449165590/019f431e-c5c8-719b-a4cb-97f7ea0cd79c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, a fun and safe space for your furry friends to play and socialize. Featuring agility equipment and comfortable seating for owners.",
      "link": "",
      "alt_text": "A fenced-in dog park area with play structures, a bench, and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f8442fac-8162-4f10-b48d-519aab7d6681",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-cd6c-737b-b1c9-fb9773b2d282.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with manicured lawns and pathways.",
        "public_id": "019f431e-cd6c-737b-b1c9-fb9773b2d282",
        "storage_key": "property/6767906449165590/019f431e-cd6c-737b-b1c9-fb9773b2d282.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Showcasing the attractive exterior of our apartment community, featuring well-maintained grounds and modern architecture.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with manicured lawns and pathways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bee77791-18bc-4ade-90bb-1a9814db2c7d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-b4c4-704d-8704-40e6cc3f7cff.webp",
      "image_media": {
        "alt_text": "Apartment complex with a dog park featuring benches and agility equipment.",
        "public_id": "019f431e-b4c4-704d-8704-40e6cc3f7cff",
        "storage_key": "property/6767906449165590/019f431e-b4c4-704d-8704-40e6cc3f7cff.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, complete with comfortable benches and fun agility equipment for your furry friends.",
      "link": "",
      "alt_text": "Apartment complex with a dog park featuring benches and agility equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_997afe43-43ad-4c81-9b02-e09fbfaf7e7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-9383-7033-9209-64b6462cfa97.webp",
      "image_media": {
        "alt_text": "Exterior of the apartment complex clubhouse and surrounding grounds.",
        "public_id": "019f431e-9383-7033-9209-64b6462cfa97",
        "storage_key": "property/6767906449165590/019f431e-9383-7033-9209-64b6462cfa97.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "The beautifully landscaped grounds and modern clubhouse welcome residents to this apartment community. Ample parking and accessibility features ensure convenience for all.",
      "link": "",
      "alt_text": "Exterior of the apartment complex clubhouse and surrounding grounds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3365a0c7-bc6d-4288-84d5-be8d0eca7937",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-9750-75e8-8179-cedc22dfffeb.webp",
      "image_media": {
        "alt_text": "Center 301 Apartments monument sign with building in background",
        "public_id": "019f431e-9750-75e8-8179-cedc22dfffeb",
        "storage_key": "property/6767906449165590/019f431e-9750-75e8-8179-cedc22dfffeb.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to Center 301 Apartments, where modern living meets convenience. Explore our beautiful community and find your perfect home.",
      "link": "",
      "alt_text": "Center 301 Apartments monument sign with building in background",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9c983453-2dbb-482d-9a7a-c1ee8b299153",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-6e51-7295-84e8-31e61ec96828.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with two stainless steel grills and a picnic table, with apartment buildings in the background.",
        "public_id": "019f431e-6e51-7295-84e8-31e61ec96828",
        "storage_key": "property/6767906449165590/019f431e-6e51-7295-84e8-31e61ec96828.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our community grilling stations, perfect for a summer barbecue.",
      "link": "",
      "alt_text": "Outdoor grilling station with two stainless steel grills and a picnic table, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_646cc306-b895-4863-9068-2b1265bd42b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-77a6-746f-ad8a-3e77769b7f60.webp",
      "image_media": {
        "alt_text": "Entrance to apartment complex with modern gray siding, stone accents, and a flower bed.",
        "public_id": "019f431e-77a6-746f-ad8a-3e77769b7f60",
        "storage_key": "property/6767906449165590/019f431e-77a6-746f-ad8a-3e77769b7f60.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome guests to your stunning apartment community with this elegant entrance featuring modern architecture and beautiful landscaping.",
      "link": "",
      "alt_text": "Entrance to apartment complex with modern gray siding, stone accents, and a flower bed.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8ac8b62e-1e06-4229-abd2-cc3c4383cf76",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-7113-71ab-a921-9b024804dfdb.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and a picnic table, with apartment buildings in the background.",
        "public_id": "019f431e-7113-71ab-a921-9b024804dfdb",
        "storage_key": "property/6767906449165590/019f431e-7113-71ab-a921-9b024804dfdb.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining at our community grilling station, featuring state-of-the-art grills and a comfortable picnic area perfect for gathering with friends and neighbors.",
      "link": "",
      "alt_text": "Outdoor grilling area with two built-in grills and a picnic table, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d7a77bc5-0804-4681-afe4-5d37050ba844",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-678b-705a-ac03-851035d924d9.webp",
      "image_media": {
        "alt_text": "Entrance to Center 301 Apartments with signage.",
        "public_id": "019f431e-678b-705a-ac03-851035d924d9",
        "storage_key": "property/6767906449165590/019f431e-678b-705a-ac03-851035d924d9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of the entrance to Center 301 Apartments, featuring brick and stone architecture, metal gates, and informative signage.",
      "link": "",
      "alt_text": "Entrance to Center 301 Apartments with signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f0bf45b0-6306-4cdf-836a-9a4b36925fd0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-7a3c-772d-984e-3bb2219e5a34.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a fire pit and chairs in front of apartment buildings.",
        "public_id": "019f431e-7a3c-772d-984e-3bb2219e5a34",
        "storage_key": "property/6767906449165590/019f431e-7a3c-772d-984e-3bb2219e5a34.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Gather around the fire pit with friends and neighbors in this inviting outdoor seating area.",
      "link": "",
      "alt_text": "Outdoor seating area with a fire pit and chairs in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d4a33dc5-c35b-41c3-b23e-620b5834001f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-78ee-717b-a621-389d6e497cb7.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a fire pit, overlooking a pool and apartment buildings.",
        "public_id": "019f431e-78ee-717b-a621-389d6e497cb7",
        "storage_key": "property/6767906449165590/019f431e-78ee-717b-a621-389d6e497cb7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy relaxing evenings by the fire pit or take a dip in the resort-style pool at our community.",
      "link": "",
      "alt_text": "Outdoor seating area with a fire pit, overlooking a pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e5e34291-a1c0-4fe8-a76a-10c4a3268caa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-5c5a-771b-ba92-682a3dd8a66f.webp",
      "image_media": {
        "alt_text": "Luxury apartment complex swimming pool with lounge chairs and buildings in the background.",
        "public_id": "019f431e-5c5a-771b-ba92-682a3dd8a66f",
        "storage_key": "property/6767906449165590/019f431e-5c5a-771b-ba92-682a3dd8a66f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by comfortable lounge chairs and lush landscaping.",
      "link": "",
      "alt_text": "Luxury apartment complex swimming pool with lounge chairs and buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_87f039dc-5d58-4f66-bf3a-461423611311",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-55fc-706b-bbed-3e4e7a6e5498.webp",
      "image_media": {
        "alt_text": "Center Apartments 301 community room with pool table, bar seating, and large garage-style doors overlooking the exterior.",
        "public_id": "019f431e-55fc-706b-bbed-3e4e7a6e5498",
        "storage_key": "property/6767906449165590/019f431e-55fc-706b-bbed-3e4e7a6e5498.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Gather in the stylish community room at Center Apartments 301, featuring a billiards table, lounge seating, and modern decor. Perfect for socializing and relaxing.",
      "link": "",
      "alt_text": "Center Apartments 301 community room with pool table, bar seating, and large garage-style doors overlooking the exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d5e1f4ed-8d79-48c6-972c-a56590dea943",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-581b-7689-8e86-e6bf176b5454.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019f431e-581b-7689-8e86-e6bf176b5454",
        "storage_key": "property/6767906449165590/019f431e-581b-7689-8e86-e6bf176b5454.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax by the resort-style pool, featuring comfortable lounge chairs and beautiful apartment buildings surrounding the amenity.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_106f315f-255b-455d-bd19-134af35b222c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-5ecc-7334-a3ee-dd5457b749f9.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "019f431e-5ecc-7334-a3ee-dd5457b749f9",
        "storage_key": "property/6767906449165590/019f431e-5ecc-7334-a3ee-dd5457b749f9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with comfortable lounge chairs and beautiful views of the surrounding apartment community.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_59e0b404-37d9-4030-93d1-d342bdbb2d04",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-5391-7724-9510-69d2d7eba46e.webp",
      "image_media": {
        "alt_text": "Community lounge area with pool table, shuffleboard, and lounge seating with TVs mounted on the wall.",
        "public_id": "019f431e-5391-7724-9510-69d2d7eba46e",
        "storage_key": "property/6767906449165590/019f431e-5391-7724-9510-69d2d7eba46e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy endless entertainment in our community lounge, featuring a pool table, shuffleboard, and comfortable seating areas perfect for socializing or relaxing.",
      "link": "",
      "alt_text": "Community lounge area with pool table, shuffleboard, and lounge seating with TVs mounted on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cdbf78ad-d071-44da-9a18-16fdf2ffdcfc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-40ca-728a-80a1-81cadfebaf75.webp",
      "image_media": {
        "alt_text": "Lobby of Center Apartments 301 with fireplace and seating",
        "public_id": "019f431e-40ca-728a-80a1-81cadfebaf75",
        "storage_key": "property/6767906449165590/019f431e-40ca-728a-80a1-81cadfebaf75.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to Center Apartments 301, featuring a modern lobby with a fireplace, comfortable seating, and elegant decor.",
      "link": "",
      "alt_text": "Lobby of Center Apartments 301 with fireplace and seating",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7f9299fb-e94b-4b48-b5ed-0d216824ee09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-3a74-727c-b0e5-d32bc0f1158f.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019f431e-3a74-727c-b0e5-d32bc0f1158f",
        "storage_key": "property/6767906449165590/019f431e-3a74-727c-b0e5-d32bc0f1158f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring cardio equipment, weight machines, and free weights for a comprehensive workout.",
      "link": "",
      "alt_text": "Well-equipped fitness center with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_917a8665-1718-442b-8465-b33257b27876",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-3a78-70ef-9e53-694257294ef9.webp",
      "image_media": {
        "alt_text": "Reception area with couches, chairs, and a front desk at Center 301 Apartments.",
        "public_id": "019f431e-3a78-70ef-9e53-694257294ef9",
        "storage_key": "property/6767906449165590/019f431e-3a78-70ef-9e53-694257294ef9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to the modern and inviting reception area at Center 301 Apartments, featuring comfortable seating and a stylish front desk.",
      "link": "",
      "alt_text": "Reception area with couches, chairs, and a front desk at Center 301 Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_206ac9bd-7434-4750-8fc8-d2987ef0f756",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-1ff7-774b-b2ce-cb88f604034c.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, weight machines, free weights, and exercise balls.",
        "public_id": "019f431e-1ff7-774b-b2ce-cb88f604034c",
        "storage_key": "property/6767906449165590/019f431e-1ff7-774b-b2ce-cb88f604034c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with cardio and strength training equipment for residents.",
      "link": "",
      "alt_text": "Gym with treadmills, weight machines, free weights, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_af7bf53d-7e89-4d26-9312-76108b5cd5d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d593f-4c25-77ef-840a-dfe10f6701a5.webp",
      "image_media": {
        "alt_text": "Center Apartments 301 monument sign with stone and wood accents.",
        "public_id": "019d593f-4c25-77ef-840a-dfe10f6701a5",
        "storage_key": "property/6767906449165590/019d593f-4c25-77ef-840a-dfe10f6701a5.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Welcome to Center Apartments 301, a premier apartment community featuring modern amenities and a convenient location. Our monument sign reflects the quality and style of the living experience offered.",
      "link": "",
      "alt_text": "Center Apartments 301 monument sign with stone and wood accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_60464e38-5394-4e0c-aa10-41dc50844e43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Jack Stack Barbecue - Martin City",
      "poi_type": "Restaurants",
      "poi_address": "13441 Holmes Rd, Kansas City, MO 64145, USA",
      "poi_short_description": "Bustling local chain known for its vast barbecue menu encompassing steak & seafood.",
      "poi_long_description": "People say this barbecue restaurant serves delicious brisket, burnt ends, ribs, and sides like beans and coleslaw. They highlight the generous portions, tasty food, and the option to mix and match meats. They also like the friendly and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-98ce-748c-a281-d2cc3585a96f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-98ce-748c-a281-d2cc3585a96f",
        "storage_key": "property/6767906449165590/019cfb3b-98ce-748c-a281-d2cc3585a96f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jackstackbbq.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=17708542045051162026&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jack-stack-barbecue---martin-city",
      "poi_latitude": "38.8827758",
      "poi_longitude": "-94.5862708",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-942-9141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12ff-728f-bf0c-1a04fcfa1b30",
        "storage_key": "property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8_JZmpbCwIcRqg1YhSphwfU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_bb5cc84c-5b98-42c3-a07d-e3643362bb4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken",
      "poi_type": "Restaurants",
      "poi_address": "1599 E North Ave, Belton, MO 64012, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "Diners say this fast food restaurant serves up delicious chicken strips, fries, and Texas toast, with a special shout-out to the Cane's sauce and coleslaw. They also highlight the friendly and efficient service, and the quick and easy ordering process.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-0041-768f-96d6-f1ed5817f84a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-0041-768f-96d6-f1ed5817f84a",
        "storage_key": "property/6767906449165590/019cfb3b-0041-768f-96d6-f1ed5817f84a.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/mo/belton/1599-e-north-ave",
      "poi_directions_map_url": "https://maps.google.com/?cid=11558165185451444714&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken",
      "poi_latitude": "38.8129744",
      "poi_longitude": "-94.510123",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-348-7745",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12ff-728f-bf0c-1a04fcfa1b30",
        "storage_key": "property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdc2WipHbwIcR6skelv_ZZqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_bf35ef8c-9c01-43d7-be05-a284b370c014",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "228 Peculiar Dr, Belton, MO 64012, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious sirloin, ribeye, and salmon, as well as tasty sides like mashed potatoes and fresh vegetables. They highlight the generous portion sizes and the cozy, laid-back atmosphere. They also like the attentive staff and fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3a-fee9-778e-829d-50be4174579e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-fee9-778e-829d-50be4174579e",
        "storage_key": "property/6767906449165590/019cfb3a-fee9-778e-829d-50be4174579e.webp",
        "width": 1280,
        "height": 962
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/missouri/belton?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=7727955129359631567&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "38.8102549",
      "poi_longitude": "-94.5031875",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-322-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12ff-728f-bf0c-1a04fcfa1b30",
        "storage_key": "property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsUl9V4zbwIcRz4Sj5T42P2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_894418be-e9a4-4fc9-b4cf-d8b27d70fca4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "1920 W Foxwood Dr, Raymore, MO 64083, USA",
      "poi_short_description": "Casual chain frying chicken to order, plus burgers, salads and shakes.",
      "poi_long_description": "People say this fast food restaurant serves tasty chicken sandwiches, nuggets, and creamy mac and cheese. They also highlight the friendly staff, quick service, and welcoming atmosphere.\n\nOther reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-98ca-70d2-b3a7-31b477706192.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-98ca-70d2-b3a7-31b477706192",
        "storage_key": "property/6767906449165590/019cfb3b-98ca-70d2-b3a7-31b477706192.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/mo/raymore-mo?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=105397196777762780&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "38.813286",
      "poi_longitude": "-94.491762",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-283-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12ff-728f-bf0c-1a04fcfa1b30",
        "storage_key": "property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJST1rBQDbwIcR3K9CKjFydgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_9d29a255-1283-4915-8094-8b1a4aba1ffe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Martin City Brewing Co. Pizza & Taproom - 135th Street",
      "poi_type": "Restaurants",
      "poi_address": "410 E 135th St, Kansas City, MO 64145, USA",
      "poi_short_description": "Craft brewery featuring a taproom for fresh beer brewed on-site, plus a pizza kitchen, wings and burgers.",
      "poi_long_description": "People say this restaurant serves delicious pizza, including a breakfast pizza with perfectly cooked sunny-side-up eggs, and a variety of other dishes like wings, salads, and wraps. They highlight the great beer selection, including gluten-free options, and the fun, lively atmosphere. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-97c4-76c0-9c1c-03db368d9eb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-97c4-76c0-9c1c-03db368d9eb3",
        "storage_key": "property/6767906449165590/019cfb3b-97c4-76c0-9c1c-03db368d9eb3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://martincitybrewingcompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7949706333552148003&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-city-brewing-co-pizza--taproom---135th-street",
      "poi_latitude": "38.8827588",
      "poi_longitude": "-94.5901362",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-268-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12ff-728f-bf0c-1a04fcfa1b30",
        "storage_key": "property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs-flb5HCwIcRI34MgMoHU24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6d897a47-0e6e-47b0-8d95-366a7e958bb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "800 Markey Pkwy, Belton, MO 64012, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "People say this home improvement store offers a wide variety of products, including hardware, food items, and toys. They also highlight the friendly and helpful staff, and the clean, well-stocked store.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-98ca-70d2-b3a7-34a4a89366cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-98ca-70d2-b3a7-34a4a89366cc",
        "storage_key": "property/6767906449165590/019cfb3b-98ca-70d2-b3a7-34a4a89366cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3341&utm_source=localcard&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6243776869074729610&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "menards",
      "poi_latitude": "38.8211018",
      "poi_longitude": "-94.5182659",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-318-9459",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4419d93ea347.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4419d93ea347",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4419d93ea347.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJic5MHH7cwIcRivr_QftZplY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_9be65194-8bba-48e1-a662-ce9bff2177f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "1306 E North Ave, Belton, MO 64012, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide selection of products and tools for home DIY and craft projects. They also highlight the helpful, knowledgeable, and friendly staff, and the easy checkout process.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3a-ffd2-769f-b3ed-b719e04a6bcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ffd2-769f-b3ed-b719e04a6bcc",
        "storage_key": "property/6767906449165590/019cfb3a-ffd2-769f-b3ed-b719e04a6bcc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Belton/MO/Belton/64012/3029?emt=MSEN?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9873965828684932306&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "38.8158928",
      "poi_longitude": "-94.5137476",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-322-2531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4419d93ea347.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4419d93ea347",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4419d93ea347.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJw2YB94bbwIcR0mQcT5tfB4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_c8827e7f-0553-4752-874c-4fbe9b57b064",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Hy-Vee",
      "poi_type": "Shopping & Retail",
      "poi_address": "1307 E North Ave, Belton, MO 64012, USA",
      "poi_short_description": "Grocery shop selling meat, baked goods, deli items, vegan foods, healthy options and fresh produce.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, meat, and vegetarian options. They also highlight the clean and organized layout, and the friendly and helpful staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-9756-715c-b3c2-b699b11b3e21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-9756-715c-b3c2-b699b11b3e21",
        "storage_key": "property/6767906449165590/019cfb3b-9756-715c-b3c2-b699b11b3e21.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://www.hy-vee.com/stores/detail.aspx?s=13&utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13057243497158291543&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hy-vee",
      "poi_latitude": "38.8119099",
      "poi_longitude": "-94.5136027",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-318-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12f7-7111-9001-5af2acca510b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12f7-7111-9001-5af2acca510b",
        "storage_key": "property/6767906449165590/019cfb3b-12f7-7111-9001-5af2acca510b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa8gUxKbbwIcRVzDmycelNLU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_62af1224-f7c8-4688-a2a8-d8475f7fc883",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "225 N Dean Ave, Raymore, MO 64083, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide selection of products and has an efficient layout that makes it easy to find what you need. They also highlight the knowledgeable and helpful staff, and the clean and well-organized store.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3a-fe93-72af-94a9-5fc8e627135b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-fe93-72af-94a9-5fc8e627135b",
        "storage_key": "property/6767906449165590/019cfb3a-fe93-72af-94a9-5fc8e627135b.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/MO-Raymore/2626?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2626-_-na-_-0-_-0&y_source=1_MTE4NDEzOC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=18363475698140801606&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "38.8106255",
      "poi_longitude": "-94.4903837",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-348-4320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4419d93ea347.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4419d93ea347",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4419d93ea347.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJccbULfHbwIcRRmozhdor2P4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_ca658bc6-afc1-45ce-896c-26c8b8f3cc5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Burlington",
      "poi_type": "Shopping & Retail",
      "poi_address": "12400 15 St, Grandview, MO 64030, USA",
      "poi_short_description": "Discount store (part of a chain) for clothing, outerwear, handbags and footwear.",
      "poi_long_description": "People say this clothing store offers a wide variety of clothing for children and adults, shoes, housewares, toys, handbags, perfumes, colognes, and art. They also highlight the affordable prices, clean and organized layout, and friendly staff.\n\nOther reviews mention the lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3a-ff43-7521-b374-5dba2eea2376.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ff43-7521-b374-5dba2eea2376",
        "storage_key": "property/6767906449165590/019cfb3a-ff43-7521-b374-5dba2eea2376.webp",
        "width": 488,
        "height": 289
      },
      "poi_business_url": "https://stores.burlington.com/mo/grandview/888/?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11939488128139094073&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "burlington",
      "poi_latitude": "38.9015922",
      "poi_longitude": "-94.527481",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-761-3321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4419d93ea347.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4419d93ea347",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4419d93ea347.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwV5azn3dwIcROWi5xTGVsaU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_fb7735dd-baad-4848-9c35-a167d32ca23b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Calvary University",
      "poi_type": "Education",
      "poi_address": "15800 Calvary Rd, Kansas City, MO 64147, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-027a-757d-889f-2de315508e74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-027a-757d-889f-2de315508e74",
        "storage_key": "property/6767906449165590/019cfb3b-027a-757d-889f-2de315508e74.webp",
        "width": 1280,
        "height": 761
      },
      "poi_business_url": "http://www.calvary.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13752870343369373082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "calvary-university",
      "poi_latitude": "38.837821",
      "poi_longitude": "-94.5446979",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-322-0110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12f4-769a-b9e1-ad6436eff6a8",
        "storage_key": "property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrQSwvsbcwIcRmjWJIrYC3L4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8ff92098-508a-42b4-b9c9-093c70cc5b0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Mid-Continent Public Library - Grandview Branch",
      "poi_type": "Education",
      "poi_address": "12930 Booth Ln, Grandview, MO 64030, USA",
      "poi_short_description": "Free branch of a library system featuring books for all ages, movies and music.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-02f7-7606-a528-5b5b10969905.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-02f7-7606-a528-5b5b10969905",
        "storage_key": "property/6767906449165590/019cfb3b-02f7-7606-a528-5b5b10969905.webp",
        "width": 500,
        "height": 281
      },
      "poi_business_url": "https://www.mymcpl.org/locations/grandview",
      "poi_directions_map_url": "https://maps.google.com/?cid=12179492877821471868&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mid-continent-public-library---grandview-branch",
      "poi_latitude": "38.8893491",
      "poi_longitude": "-94.5218101",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-763-0550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12f0-725c-8ddf-8f25edfb6d29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12f0-725c-8ddf-8f25edfb6d29",
        "storage_key": "property/6767906449165590/019cfb3b-12f0-725c-8ddf-8f25edfb6d29.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4XJQ-3fdwIcRfOzyHj5ABqk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_4b72e20d-f81d-48f2-9361-f3bb3ad777b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Belton Missouri Historical Railroad",
      "poi_type": "Entertainment",
      "poi_address": "502 E Walnut St, Belton, MO 64012, USA",
      "poi_short_description": "Vintage trains and railroad cars on display at a low-key, family-friendly heritage site.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-03bd-7081-a4f6-5989c9131fe7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-03bd-7081-a4f6-5989c9131fe7",
        "storage_key": "property/6767906449165590/019cfb3b-03bd-7081-a4f6-5989c9131fe7.webp",
        "width": 1280,
        "height": 805
      },
      "poi_business_url": "http://www.beltonrailroad.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13373056685714473833&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "belton-missouri-historical-railroad",
      "poi_latitude": "38.8126498",
      "poi_longitude": "-94.5317924",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-441-8276",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-130c-7756-804c-0d16ebef24cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-130c-7756-804c-0d16ebef24cc",
        "storage_key": "property/6767906449165590/019cfb3b-130c-7756-804c-0d16ebef24cc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJzaSItXzbwIcRaYMswTOklrk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_41e9fa51-6a4e-4953-a47b-80ae04bf988d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Southwick Stadium",
      "poi_type": "Entertainment",
      "poi_address": "813 W North Ave, Belton, MO 64012, USA",
      "poi_short_description": "Large, clean field and stadium for high school sports, including football, soccer and track.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10173992165953558365&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southwick-stadium",
      "poi_latitude": "38.8108483",
      "poi_longitude": "-94.5542719",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-489-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-134d-70fc-863a-5e91b1d7e113.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-134d-70fc-863a-5e91b1d7e113",
        "storage_key": "property/6767906449165590/019cfb3b-134d-70fc-863a-5e91b1d7e113.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqWRaIlfbwIcRXddEh_hHMY0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_0019b3a9-b8cd-44ab-aa6a-1dfda7110a39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Belton Museum",
      "poi_type": "Entertainment",
      "poi_address": "512 Main St, Belton, MO 64012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.beltonhistoricalsociety.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5590888949497786698&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "belton-museum",
      "poi_latitude": "38.8106912",
      "poi_longitude": "-94.5310983",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-322-3977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-130c-7756-804c-0d16ebef24cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-130c-7756-804c-0d16ebef24cc",
        "storage_key": "property/6767906449165590/019cfb3b-130c-7756-804c-0d16ebef24cc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJo6hsVHvbwIcRSvF4teDTlk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1459bcf8-d50a-4647-98bf-78e860a8f96b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "124 Cedar Tree Sq, Belton, MO 64012, USA",
      "poi_short_description": "Closeout chain selling a range of products, such as housewares, grocery items, furniture & apparel.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and amenities, including lockers, bathrooms, and showers. They highlight the clean and welcoming environment, and the friendly and helpful staff. They also like the consistent availability of cleaning supplies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-9993-71ef-8d9f-71663806bc46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-9993-71ef-8d9f-71663806bc46",
        "storage_key": "property/6767906449165590/019cfb3b-9993-71ef-8d9f-71663806bc46.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/belton-mo?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11678393819347840687&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.8146861",
      "poi_longitude": "-94.5089486",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-322-3395",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4a0cdc830ed6",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU9NtUMUhd0ARr25YzU39EaI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f62d413e-7f2b-48db-9444-e772db3ef10e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "High Blue",
      "poi_type": "Health and Wellness",
      "poi_address": "16400 N Mullen Rd, Belton, MO 64012, USA",
      "poi_short_description": "Modern fitness center featuring a heated pool for year-round enjoyment, plus group classes.",
      "poi_long_description": "People say this fitness center offers a swimming pool with warm and cool sides, a sauna, a gymnasium, and a gym. They highlight the clean facilities, friendly people, and the variety of offerings, including a kids' corner and classes. They also like the accommodating staff.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.beltonparks.org/27/High-Blue",
      "poi_directions_map_url": "https://maps.google.com/?cid=3689367982997291541&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "high-blue",
      "poi_latitude": "38.8258451",
      "poi_longitude": "-94.5150681",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-348-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4a0cdc830ed6",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkd0nbHvcwIcRFcJAKKJEMzM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_59c3013f-17b5-4497-a3b8-0435efa32e23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Belton Animal Clinic & Exotic Care Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1308 N Scott Ave, Belton, MO 64012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-04bb-7146-ac3c-5db220d8d26d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-04bb-7146-ac3c-5db220d8d26d",
        "storage_key": "property/6767906449165590/019cfb3b-04bb-7146-ac3c-5db220d8d26d.webp",
        "width": 739,
        "height": 416
      },
      "poi_business_url": "http://www.beltonanimal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18268701422698224205&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "belton-animal-clinic--exotic-care-center",
      "poi_latitude": "38.8381506",
      "poi_longitude": "-94.5344639",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-331-3120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4a0cdc830ed6",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBypSO-3cwIcRTdqZ9yZ3h_0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_86b7614b-ddab-444e-9256-1b072fd9f736",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Missouri Elite Gymnastics Academy",
      "poi_type": "Health and Wellness",
      "poi_address": "19601 Harrelson Dr, Belton, MO 64012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-0509-778e-8cd9-5ff12330e029.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-0509-778e-8cd9-5ff12330e029",
        "storage_key": "property/6767906449165590/019cfb3b-0509-778e-8cd9-5ff12330e029.webp",
        "width": 1280,
        "height": 1086
      },
      "poi_business_url": "http://www.moelitegym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9601956899759119572&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "missouri-elite-gymnastics-academy",
      "poi_latitude": "38.766948",
      "poi_longitude": "-94.49245100000002",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-425-4445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12f4-769a-b9e1-ad6436eff6a8",
        "storage_key": "property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ7SEZzDawIcR1NzATu0AQYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b6ddea60-c4b7-4ac4-bbdd-312d969637aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Burge Bird Services & Rescue",
      "poi_type": "Health and Wellness",
      "poi_address": "13833 US-71, Grandview, MO 64030, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-9afc-7519-8d20-e02f48df50b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-9afc-7519-8d20-e02f48df50b0",
        "storage_key": "property/6767906449165590/019cfb3b-9afc-7519-8d20-e02f48df50b0.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://burgebirdservices.homestead.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8681385749587817935&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "burge-bird-services--rescue",
      "poi_latitude": "38.8727163",
      "poi_longitude": "-94.5253628",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-356-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4a0cdc830ed6",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk6_aPgndwIcRz_VR4ld6eng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_55739e65-d761-4755-bfca-2a053f06a529",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "201 N Cedar St A, Belton, MO 64012, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-9aa4-7179-b67f-ae0fac5d3121.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-9aa4-7179-b67f-ae0fac5d3121",
        "storage_key": "property/6767906449165590/019cfb3b-9aa4-7179-b67f-ae0fac5d3121.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/mo/belton/201-n-cedar-dr?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8223608228350555992&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "38.8161765",
      "poi_longitude": "-94.5238363",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-322-8112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4a0cdc830ed6",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgxx09obbwIcRWHfQ9hwgIHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_eb48104c-da64-44b1-b305-9b414d8b36c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Grandview Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1006 Main St, Grandview, MO 64030, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-0939-74b9-a59a-c58ea8e1336c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-0939-74b9-a59a-c58ea8e1336c",
        "storage_key": "property/6767906449165590/019cfb3b-0939-74b9-a59a-c58ea8e1336c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.grandviewvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4062172026996496235&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "grandview-animal-hospital",
      "poi_latitude": "38.8895358",
      "poi_longitude": "-94.5333075",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-761-5071",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4a0cdc830ed6",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1ou-mfdwIcRa5enre-7Xzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_65d4d5bf-9117-4e39-ac7b-ff31bbbf89e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Anthony’s Barber Shop",
      "poi_type": "Health and Wellness",
      "poi_address": "1312 E North Ave, Belton, MO 64012, USA",
      "poi_short_description": "Barber shop offering haircuts and beard trims in the Belton Towne Center.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-088b-755d-a758-bce427bed500.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-088b-755d-a758-bce427bed500",
        "storage_key": "property/6767906449165590/019cfb3b-088b-755d-a758-bce427bed500.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://dot.cards/antwonbarber_33",
      "poi_directions_map_url": "https://maps.google.com/?cid=3932916290426992973&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anthonys-barber-shop",
      "poi_latitude": "38.8143276",
      "poi_longitude": "-94.5134098",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-425-4308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4a0cdc830ed6",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeXf89IHxwIcRTXk_VoeGlDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_f1b407e0-6f42-4047-b507-e8b2b8c90de1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Sport Clips Haircuts of Belton Towne Center",
      "poi_type": "Health and Wellness",
      "poi_address": "904A E North Ave, Belton, MO 64012, USA",
      "poi_short_description": "Sports-themed barbershop specializing in haircuts for men and boys with online check-in.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-08fd-77fe-a4d8-54adab7d8c5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-08fd-77fe-a4d8-54adab7d8c5a",
        "storage_key": "property/6767906449165590/019cfb3b-08fd-77fe-a4d8-54adab7d8c5a.webp",
        "width": 1279,
        "height": 720
      },
      "poi_business_url": "https://sportclips.com/us-mo-belton-mo906?utm_source=google&utm_medium=link&utm_campaign=gbp&utm_content=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=11174773836774446571&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sport-clips-haircuts-of-belton-towne-center",
      "poi_latitude": "38.8145243",
      "poi_longitude": "-94.5190032",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-331-1991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4a0cdc830ed6",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk40oqYHbwIcR6xVFGpnFFJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_5cf3bcf8-3920-43da-8461-f9a7387893b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Raymore Veterinary Center",
      "poi_type": "Health and Wellness",
      "poi_address": "411 Remington Plaza Ct, Raymore, MO 64083, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-9c0e-7267-838a-da9e32d02fb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-9c0e-7267-838a-da9e32d02fb8",
        "storage_key": "property/6767906449165590/019cfb3b-9c0e-7267-838a-da9e32d02fb8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://raymoreveterinarycenter.com/?utm_source=gmb&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=9544001128209475041&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raymore-veterinary-center",
      "poi_latitude": "38.813173",
      "poi_longitude": "-94.4714069",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-331-2626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4a0cdc830ed6",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Rgkm1HZwIcR4WXatnUac4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_d401e4df-b3bf-480f-8c29-629199945268",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Belton Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "17065 US-71, Belton, MO 64012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.hcamidwest.com/locations/belton-regional-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=5445054980273654450&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "belton-regional-medical-center",
      "poi_latitude": "38.8159187",
      "poi_longitude": "-94.5027117",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-348-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12f4-769a-b9e1-b0a7a7992787.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12f4-769a-b9e1-b0a7a7992787",
        "storage_key": "property/6767906449165590/019cfb3b-12f4-769a-b9e1-b0a7a7992787.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJl4t8LorbwIcRssquyae4kEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_5c038ef2-f31a-443a-92f5-d99c856d7fdb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Eagles' Landing Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4200 Bong Ave, Belton, MO 64012, USA",
      "poi_short_description": "Well-maintained, 18-hole golf course with friendly staff.",
      "poi_long_description": "People say this golf course offers a fun and challenging layout. They also highlight the reasonable prices and well-maintained conditions.\n\nOther reviews mention the pace of play can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-08cc-73a9-aab2-dc8df66685dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-08cc-73a9-aab2-dc8df66685dc",
        "storage_key": "property/6767906449165590/019cfb3b-08cc-73a9-aab2-dc8df66685dc.webp",
        "width": 746,
        "height": 542
      },
      "poi_business_url": "http://www.eagleslandinggolfcourse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5034003552100645461&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eagles-landing-golf-course",
      "poi_latitude": "38.8337546",
      "poi_longitude": "-94.5484899",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-318-0004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1317-7533-b054-75b434707248.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1317-7533-b054-75b434707248",
        "storage_key": "property/6767906449165590/019cfb3b-1317-7533-b054-75b434707248.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJOWWoELjcwIcRVXoDMY9f3EU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_d44abe16-67ec-47b3-9b56-f8216b2968c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Markey Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "615 Markey Rd, Belton, MO 64012, USA",
      "poi_short_description": "Electric scoreboards are found on each ballpark at this city park with a playground & restrooms.",
      "poi_long_description": "People say this city park is a nice venue for softball and baseball. They also highlight the clean facilities and ample parking.\n\nOther reviews mention the fields can be rough.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-0af7-770f-b0af-67bc80941a84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-0af7-770f-b0af-67bc80941a84",
        "storage_key": "property/6767906449165590/019cfb3b-0af7-770f-b0af-67bc80941a84.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.beltonparks.org/153/Markey-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17130747521195664885&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "markey-park",
      "poi_latitude": "38.8274094",
      "poi_longitude": "-94.5505537",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-348-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-15d9-7319-881b-0a4e4f1e01e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-15d9-7319-881b-0a4e4f1e01e6",
        "storage_key": "property/6767906449165590/019cfb3b-15d9-7319-881b-0a4e4f1e01e6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJx8d9ybrcwIcR9WXFoRukvO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_8b883c62-473a-43ee-a60c-5a61bad416c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Creekmoor Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1112 E 163rd St, Raymore, MO 64083, USA",
      "poi_short_description": "Golf course woven around homes with a challenging layout, a tavern, and friendly staff.",
      "poi_long_description": "People say this golf course offers challenging holes and well-maintained fairways. They highlight the course conditions are great, the greens roll fast and true, and the tee boxes have grass. They also like the fun and beautiful country course.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.thegolfclubatcreekmoor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14324612679737097966&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "creekmoor-golf-course",
      "poi_latitude": "38.8280466",
      "poi_longitude": "-94.4727941",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-331-2621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1317-7533-b054-75b434707248.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1317-7533-b054-75b434707248",
        "storage_key": "property/6767906449165590/019cfb3b-1317-7533-b054-75b434707248.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJhZVC_C3fwIcR7j7JUFY_y8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_8eaa8315-bbed-402b-b123-db89f933b861",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Hawk Ridge Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Raymore, MO 64083, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a lake, fishing, walking trails, a playground, and a mountain bike trail. They highlight the clean facilities, ample parking, and the variety of activities suitable for all ages. They also like the peaceful and serene atmosphere, perfect for leisurely strolls and picnics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-9d38-70c6-8f59-71ef8bcd5266.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-9d38-70c6-8f59-71ef8bcd5266",
        "storage_key": "property/6767906449165590/019cfb3b-9d38-70c6-8f59-71ef8bcd5266.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.raymore.com/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=3864412770488533730&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hawk-ridge-park",
      "poi_latitude": "38.8208398",
      "poi_longitude": "-94.4695365",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-322-2791",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-15d9-7319-881b-0a4e4f1e01e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-15d9-7319-881b-0a4e4f1e01e6",
        "storage_key": "property/6767906449165590/019cfb3b-15d9-7319-881b-0a4e4f1e01e6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ59DiYq3ewIcR4sJzsvAmoTU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ce33e0ce-fa7d-4444-854f-5711271afddd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Meadowmere Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13610 Byars Rd, Grandview, MO 64030, USA",
      "poi_short_description": "Clean, shaded playground for kids and families that features a rock wall and treehouse play sets.",
      "poi_long_description": "People say this city park offers a variety of fun outdoor activities, including a playground, walking trails, and a skatepark. They highlight the clean and well-maintained facilities, and the beautiful natural setting with wildlife. They also like the shady areas and the covered pavilion, which is suitable for picnics and gatherings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-0bf1-7278-81bb-8e22d0c3a53e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-0bf1-7278-81bb-8e22d0c3a53e",
        "storage_key": "property/6767906449165590/019cfb3b-0bf1-7278-81bb-8e22d0c3a53e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.grandview.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14697811259602704761&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "meadowmere-park",
      "poi_latitude": "38.876635",
      "poi_longitude": "-94.510274",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-316-4888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-15d9-7319-881b-0a4e4f1e01e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-15d9-7319-881b-0a4e4f1e01e6",
        "storage_key": "property/6767906449165590/019cfb3b-15d9-7319-881b-0a4e4f1e01e6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw2-EVrvdwIcReRlb4Hcd-cs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_50a152ba-f15c-4fac-b92e-05643408c51c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "City of Grandview",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 Main St, Grandview, MO 64030, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-0cb3-745f-8876-ff2af5ae42ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-0cb3-745f-8876-ff2af5ae42ca",
        "storage_key": "property/6767906449165590/019cfb3b-0cb3-745f-8876-ff2af5ae42ca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.grandview.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6401752835261494966&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-grandview",
      "poi_latitude": "38.8898381",
      "poi_longitude": "-94.5313931",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-316-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12f0-725c-8ddf-8f25edfb6d29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12f0-725c-8ddf-8f25edfb6d29",
        "storage_key": "property/6767906449165590/019cfb3b-12f0-725c-8ddf-8f25edfb6d29.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbyrTi13wwIcRtnacJUmY11g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_6e724b48-a30f-4c8e-8974-1ccc53b03d7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Safe Fleet",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6800 E 163rd St, Belton, MO 64012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.safefleet.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14081530596663691963&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "safe-fleet",
      "poi_latitude": "38.8276867",
      "poi_longitude": "-94.5198884",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 844-258-8178",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4a0cdc830ed6",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6rqy2LcwIcRuwrvc3ila8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0afd3511-a1b8-4eae-99ad-010cc5407689",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Rom Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6800 E 163rd St, Belton, MO 64012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-0e54-7345-b477-23dd7ba4f9db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-0e54-7345-b477-23dd7ba4f9db",
        "storage_key": "property/6767906449165590/019cfb3b-0e54-7345-b477-23dd7ba4f9db.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.romcorp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2952123691068670914&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rom-corporation",
      "poi_latitude": "38.8275474",
      "poi_longitude": "-94.5197348",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-318-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4a0cdc830ed6",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUzC2JH3cwIcRwsMpI9sM-Cg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_659b9d2a-4367-4469-8909-d4d5da1165d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Constructive Playthings",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13201 Arrington Rd, Grandview, MO 64030, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-0e7d-747c-99cb-32eb40300597.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-0e7d-747c-99cb-32eb40300597",
        "storage_key": "property/6767906449165590/019cfb3b-0e7d-747c-99cb-32eb40300597.webp",
        "width": 1280,
        "height": 502
      },
      "poi_business_url": "https://constructiveplaythings.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3477794898237268461&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "constructive-playthings",
      "poi_latitude": "38.8838424",
      "poi_longitude": "-94.5477676",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-761-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4a0cdc830ed6",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWUJrkbdwIcR7SEZpwicQzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b9597238-2cf2-4e9c-be95-d607aabba913",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Van Keppel Used Parts",
      "poi_type": "Major Employers & Offices",
      "poi_address": "15360 Hangar Rd, Kansas City, MO 64147, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://vankeppel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6814034693720019521&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "van-keppel-used-parts",
      "poi_latitude": "38.8473602",
      "poi_longitude": "-94.5549817",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4a0cdc830ed6",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3xvF09HcwIcRQZJennNQkF4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7771d928-21dc-42a7-85ab-f9b6d8fb3076",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Kentucky Trail Elementary",
      "poi_type": "Education",
      "poi_address": "8301 E 163rd St, Belton, MO 64012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7911-bf2f-74ec-8994-29e4b201b394.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-bf2f-74ec-8994-29e4b201b394",
        "storage_key": "property/6767906449165590/019d7911-bf2f-74ec-8994-29e4b201b394.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://kentuckytrail.beltonschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3755863711240129338&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kentucky-trail-elementary",
      "poi_latitude": "38.8262639",
      "poi_longitude": "-94.4950094",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-348-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12f4-769a-b9e1-ad6436eff6a8",
        "storage_key": "property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrbgomw3cwIcROos_XSWCHzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d621e37c-e937-40fe-9559-127f5bad7600",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "CREEKMOOR ELEMENTARY",
      "poi_type": "Education",
      "poi_address": "1501 Creekmoor Dr, Raymore, MO 64083, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.raypec.k12.mo.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10838805041997790656&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "creekmoor-elementary",
      "poi_latitude": "38.8283647",
      "poi_longitude": "-94.4802174",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-892-1675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12f4-769a-b9e1-ad6436eff6a8",
        "storage_key": "property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiVrW6KbewIcRwL39XcIra5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_4c3dafc8-a8ea-40db-9cbb-7572802fd0b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Wilckens STEAM Academy at Hillcrest",
      "poi_type": "Education",
      "poi_address": "106 S Hillcrest Rd, Belton, MO 64012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.beltonschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11903605747955345480&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wilckens-steam-academy-at-hillcrest",
      "poi_latitude": "38.8144021",
      "poi_longitude": "-94.5420558",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-348-1130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12f4-769a-b9e1-ad6436eff6a8",
        "storage_key": "property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxfSGC2DbwIcRSCgtGVwaMqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_ff47f3c6-4c3f-4b9b-af6d-7a56f1609626",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Belton Middle School",
      "poi_type": "Education",
      "poi_address": "107 Pirate Pkwy, Belton, MO 64012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7911-c078-7218-a9e8-adae83bb1dae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c078-7218-a9e8-adae83bb1dae",
        "storage_key": "property/6767906449165590/019d7911-c078-7218-a9e8-adae83bb1dae.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bms.beltonschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6847341136338044670&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "belton-middle-school",
      "poi_latitude": "38.8070763",
      "poi_longitude": "-94.5366749",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-489-7060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12f4-769a-b9e1-ad6436eff6a8",
        "storage_key": "property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrwgfTmPbwIcR_kZZF3ykBl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e52da717-d944-47ea-9700-80015e221040",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Belton High School",
      "poi_type": "Education",
      "poi_address": "801 W North Ave, Belton, MO 64012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7911-c094-7420-993b-6ebad8375e87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c094-7420-993b-6ebad8375e87",
        "storage_key": "property/6767906449165590/019d7911-c094-7420-993b-6ebad8375e87.webp",
        "width": 1280,
        "height": 725
      },
      "poi_business_url": "https://bhs.beltonschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1678977633831722442&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "belton-high-school",
      "poi_latitude": "38.813635",
      "poi_longitude": "-94.552271",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-489-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12f4-769a-b9e1-ad6436eff6a8",
        "storage_key": "property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhWgJaF_bwIcRyp1dKkPtTBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_9fed017f-d274-421b-b777-13c633286202",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Lee's Summit West High School",
      "poi_type": "Education",
      "poi_address": "2600 SW Ward Rd, Lee's Summit, MO 64082, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7911-bf59-74c4-9d31-d08d22673ed6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-bf59-74c4-9d31-d08d22673ed6",
        "storage_key": "property/6767906449165590/019d7911-bf59-74c4-9d31-d08d22673ed6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lswhs.lsr7.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3931740435250045659&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lee-s-summit-west-high-school",
      "poi_latitude": "38.8732016",
      "poi_longitude": "-94.3996285",
      "poi_miles_from_property": "10.5 mi",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 816-986-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12f4-769a-b9e1-ad6436eff6a8",
        "storage_key": "property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZfiQAIbfwIcR22IeOBhZkDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_8c7189cb-e72c-4b1f-9f16-20af25b7aa10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7911-c831-7069-b8cc-ec851719516e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c831-7069-b8cc-ec851719516e",
        "storage_key": "property/6767906449165590/019d7911-c831-7069-b8cc-ec851719516e.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "18.2 mi",
      "poi_walking_minutes": "6 hours 43 mins",
      "poi_biking_minutes": "1 hour 43 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12f4-769a-b9e1-ad6436eff6a8",
        "storage_key": "property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e3c056e3-5b00-438f-a204-1ff5a1981e94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Calvary University Student Life Center",
      "poi_type": "Education",
      "poi_address": "512 Bong Ave, Belton, MO 64012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7911-de6a-7499-a95b-d180902f7d98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-de6a-7499-a95b-d180902f7d98",
        "storage_key": "property/6767906449165590/019d7911-de6a-7499-a95b-d180902f7d98.webp",
        "width": 1280,
        "height": 672
      },
      "poi_business_url": "http://www.calvary.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10056076177122367658&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "calvary-university-student-life-center",
      "poi_latitude": "38.834568",
      "poi_longitude": "-94.5465164",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-322-0110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12f4-769a-b9e1-ad6436eff6a8",
        "storage_key": "property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6TmdU_LdwIcRqpil8wBcjos",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d8b9ec61-01a5-4d13-a2ec-875c1ed99ad9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Avila University",
      "poi_type": "Education",
      "poi_address": "11901 Wornall Rd, Kansas City, MO 64145, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7911-d8c9-7361-9e50-61ed6b55ced9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d8c9-7361-9e50-61ed6b55ced9",
        "storage_key": "property/6767906449165590/019d7911-d8c9-7361-9e50-61ed6b55ced9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.avila.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8811314658076620813&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "avila-university",
      "poi_latitude": "38.9123643",
      "poi_longitude": "-94.5914699",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 816-942-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12f4-769a-b9e1-ad6436eff6a8",
        "storage_key": "property/6767906449165590/019cfb3b-12f4-769a-b9e1-ad6436eff6a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXdxaIDrowIcRDXjZRv8TSHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a176aca7-b6ab-4523-9d6d-1e646c77904a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "La Nonna Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "811 E North Ave, Belton, MO 64012, USA",
      "poi_short_description": "Lobster ravioli, stuffed mushrooms, and other Italian staples offered in a casual, family-friendly setting.",
      "poi_long_description": "People say this Italian restaurant serves delicious lobster ravioli, shrimp and scallop Alfredo, and Gorgonzola risotto. They highlight the reasonable prices and the authentic, high-quality food. They also like the attentive and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7911-d150-720e-9df2-5d9898c0992b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d150-720e-9df2-5d9898c0992b",
        "storage_key": "property/6767906449165590/019d7911-d150-720e-9df2-5d9898c0992b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orderlanonnabelton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11874322158231374261&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "la-nonna-italian-restaurant",
      "poi_latitude": "38.813344",
      "poi_longitude": "-94.5208196",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-388-3813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12ff-728f-bf0c-1a04fcfa1b30",
        "storage_key": "property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5xEVB6HbwIcRtUnuDRcRyqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_45b60e6f-07ec-4ec0-a6b7-4bbd70ba6aca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "1424 E North Ave, Belton, MO 64012, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Some diners say this Mexican restaurant serves up delicious burrito bowls and bowls with fresh ingredients, such as the new chicken, steak, and brisket.\n\nOther reviews mention the portions can be small and the online ordering can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7911-d211-7777-ada6-80efe1b7346b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d211-7777-ada6-80efe1b7346b",
        "storage_key": "property/6767906449165590/019d7911-d211-7777-ada6-80efe1b7346b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.chipotle.com/mo/belton/1424-e-north-ave?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=1848",
      "poi_directions_map_url": "https://maps.google.com/?cid=3009552255648074126&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "38.8140062",
      "poi_longitude": "-94.510089",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-331-1224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12ff-728f-bf0c-1a04fcfa1b30",
        "storage_key": "property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_aMnjojbwIcRjgnhytQTxCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_ddba5d57-4337-4e47-bc2a-4f9fda385a69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "6751 E 163rd St, Belton, MO 64012, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "People say this restaurant serves delicious meatloaf, chicken and dumplings, and chicken fried chicken. They also highlight the generous portions, wide variety of comforting Southern favorites, and the cozy, rustic atmosphere.\n\nOther reviews mention the biscuits can be dry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7911-dc6b-703e-84a3-f02d781f3763.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-dc6b-703e-84a3-f02d781f3763",
        "storage_key": "property/6767906449165590/019d7911-dc6b-703e-84a3-f02d781f3763.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/mo/belton/762/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=13683081160861231237&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "38.8256586",
      "poi_longitude": "-94.5189593",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-318-9665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12ff-728f-bf0c-1a04fcfa1b30",
        "storage_key": "property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqzZn8dvdwIcRhSj52dER5L0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_bfbae98d-b787-429c-8343-9c438c80f9bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Bonito Casa Mexico",
      "poi_type": "Restaurants",
      "poi_address": "704 E North Ave, Belton, MO 64012, USA",
      "poi_short_description": "Comfortable restaurant offering typical Mexican fare, including fajitas, plus margaritas.",
      "poi_long_description": "People say this Mexican restaurant serves delicious tacos, burritos, and specialty plates like chilaquiles. They also highlight the friendly service, reasonable prices, and family-friendly atmosphere.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7911-e249-726c-a5a5-8d8a834dab74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e249-726c-a5a5-8d8a834dab74",
        "storage_key": "property/6767906449165590/019d7911-e249-726c-a5a5-8d8a834dab74.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bonitocasamexicorestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12678148990609221492&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bonito-casa-mexico",
      "poi_latitude": "38.814518",
      "poi_longitude": "-94.521787",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-322-3337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12ff-728f-bf0c-1a04fcfa1b30",
        "storage_key": "property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr40Rg3_bwIcRdGe90lXV8a8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_4f744743-45e2-4130-a46a-8c34a669090a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Tokyo Japanese Steak House & Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "17041 Bel- Ray Blvd, Belton, MO 64012, USA",
      "poi_short_description": "Casual eatery featuring a large menu of Asian-inspired meals, from sushi to hibachi specialties (but no tableside cooking).",
      "poi_long_description": "People say this Japanese restaurant serves delicious sushi, hibachi, and fried rice. They highlight the fresh ingredients, generous portions, and reasonable prices. They also like the friendly staff and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7911-ebbb-740a-b50c-7a3465891dc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ebbb-740a-b50c-7a3465891dc1",
        "storage_key": "property/6767906449165590/019d7911-ebbb-740a-b50c-7a3465891dc1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tokyobeltonmo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8351129546984422912&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tokyo-japanese-steak-house-sushi-bar",
      "poi_latitude": "38.814151",
      "poi_longitude": "-94.4967326",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-535-5377",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12ff-728f-bf0c-1a04fcfa1b30",
        "storage_key": "property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA4ycQPTbwIcRAH5GqRMs5XM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_e6e03615-96d4-4594-a36b-8f738ef4e8b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "One More Scoop",
      "poi_type": "Restaurants",
      "poi_address": "803 E North Ave, Belton, MO 64012, USA",
      "poi_short_description": "Local shop offering homemade ice cream in creative flavors, plus sorbet, cookies and waffles.",
      "poi_long_description": "Ice people say this ice cream shop offers rich, creamy ice cream with creative and flavorful seasonal options, and delicious shakes. They also highlight the friendly and helpful service, and the enjoyable outdoor seating area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7911-f16e-7075-b27a-7f9b1283be0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f16e-7075-b27a-7f9b1283be0a",
        "storage_key": "property/6767906449165590/019d7911-f16e-7075-b27a-7f9b1283be0a.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://onemorescoopicecream.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17161125271122318675&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "one-more-scoop",
      "poi_latitude": "38.8133861",
      "poi_longitude": "-94.5211161",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-929-1194",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12ff-728f-bf0c-1a04fcfa1b30",
        "storage_key": "property/6767906449165590/019cfb3b-12ff-728f-bf0c-1a04fcfa1b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5_zFaPzbwIcRU5U5s4KQKO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "custom_a3f0642a-7cec-4331-bada-ef88f0308b7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Dutch Bros Coffee",
      "poi_type": "Restaurants",
      "poi_address": "1733 E North Ave, Belton, MO 64012, USA",
      "poi_short_description": "Fun-loving drive-thru serving up customized coffees, Rebel energy drinks, cold brew, tea & more.",
      "poi_long_description": "People say this coffee shop serves delicious coffee, shakes, and breakfast sliders. They highlight the generous serving sizes, diverse menu, and fun seasonal drinks. They also like the friendly, efficient service and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7911-fb8c-73cf-8559-3128a09026be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-fb8c-73cf-8559-3128a09026be",
        "storage_key": "property/6767906449165590/019d7911-fb8c-73cf-8559-3128a09026be.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dutchbros.com/locations/mo/belton/1733-e-north-ave?y_source=1_MzA1ODYxMzQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10751587348629099636&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dutch-bros-coffee",
      "poi_latitude": "38.8130512",
      "poi_longitude": "-94.5078231",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 877-899-2767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7912-1e5e-719c-b035-82c3a4bb503a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-1e5e-719c-b035-82c3a4bb503a",
        "storage_key": "property/6767906449165590/019d7912-1e5e-719c-b035-82c3a4bb503a.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ94gfIyzbwIcRdBSfrrpPNZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_62781dff-c114-42dd-a6e3-ec01c7e49578",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "1106 E North Ave, Belton, MO 64012, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7912-0119-778b-9f68-82c736fcfe3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0119-778b-9f68-82c736fcfe3b",
        "storage_key": "property/6767906449165590/019d7912-0119-778b-9f68-82c736fcfe3b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/1025410",
      "poi_directions_map_url": "https://maps.google.com/?cid=6230759300491487656&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "38.81598",
      "poi_longitude": "-94.51616",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-331-3516",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7912-1e5e-719c-b035-82c3a4bb503a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-1e5e-719c-b035-82c3a4bb503a",
        "storage_key": "property/6767906449165590/019d7912-1e5e-719c-b035-82c3a4bb503a.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJNynjooHbwIcRqKnBYpIaeFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_7688f2a6-4a69-40bd-bb12-ac1575a9bdfa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1106 E North Ave, Belton, MO 64012, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7911-fee3-756e-9b24-b252f5983f51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-fee3-756e-9b24-b252f5983f51",
        "storage_key": "property/6767906449165590/019d7911-fee3-756e-9b24-b252f5983f51.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/belton/1538",
      "poi_directions_map_url": "https://maps.google.com/?cid=548036761070656595&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "38.81615499999999",
      "poi_longitude": "-94.5157175",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-331-3516",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4419d93ea347.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4419d93ea347",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4419d93ea347.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJz9tANYfbwIcRU9x404cEmwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_a3a8b552-054e-4898-a277-323652688d8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Price Chopper",
      "poi_type": "Shopping & Retail",
      "poi_address": "109 N Cedar St, Belton, MO 64012, USA",
      "poi_short_description": "Grocery store offering organic products and prepared foods, plus a salad bar and check cashing.",
      "poi_long_description": "People say this grocery store offers a wide range of choices across all food options, including fresh fruit, meat, and fish. They also highlight the clean and organized store, and the friendly and helpful staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7912-0364-7570-a3f7-85f2cb79e1ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0364-7570-a3f7-85f2cb79e1ac",
        "storage_key": "property/6767906449165590/019d7912-0364-7570-a3f7-85f2cb79e1ac.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mypricechopper.com/store-details?storeId=104",
      "poi_directions_map_url": "https://maps.google.com/?cid=7536855625609819729&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "price-chopper",
      "poi_latitude": "38.8157665",
      "poi_longitude": "-94.5242546",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-322-1088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12f7-7111-9001-5af2acca510b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12f7-7111-9001-5af2acca510b",
        "storage_key": "property/6767906449165590/019cfb3b-12f7-7111-9001-5af2acca510b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ45u9y47bwIcRUbbgb0JKmGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2f924712-56cc-45a2-8da0-16dd6d32ff06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "1011 E North Ave, Belton, MO 64012, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Shoppers say this supermarket offers great prices on groceries, with a good selection of produce, dairy, and pantry staples. They also highlight the friendly and helpful staff, and the clean and well-maintained store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7912-0594-71fc-a99d-7787daaf638c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0594-71fc-a99d-7787daaf638c",
        "storage_key": "property/6767906449165590/019d7912-0594-71fc-a99d-7787daaf638c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://info.aldi.us/stores/l/mo/belton/1011-e-north-avenue/f306",
      "poi_directions_map_url": "https://maps.google.com/?cid=13757117672371684197&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "38.813246",
      "poi_longitude": "-94.517956",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-12f7-7111-9001-5af2acca510b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-12f7-7111-9001-5af2acca510b",
        "storage_key": "property/6767906449165590/019cfb3b-12f7-7111-9001-5af2acca510b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg8IdQIHbwIcRZYP2eqIZ674",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_ca47442c-69e2-4519-be3a-dd59f331abb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Raymore Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "20712 N Dean Ave, Belton, MO 64012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7912-0acf-75ae-a6cf-1ffdddcd16eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0acf-75ae-a6cf-1ffdddcd16eb",
        "storage_key": "property/6767906449165590/019d7912-0acf-75ae-a6cf-1ffdddcd16eb.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14561708311654638939&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "raymore-walmart-supercenter",
      "poi_latitude": "38.8110914",
      "poi_longitude": "-94.4953734",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-322-5455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7912-1efc-7564-ac98-09d3f7a2d01d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-1efc-7564-ac98-09d3f7a2d01d",
        "storage_key": "property/6767906449165590/019d7912-1efc-7564-ac98-09d3f7a2d01d.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJi4Z13_PbwIcRWyUH546UFco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_8d8d625c-d536-4510-8b33-8ec5f83a6e69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "141 N Dean Ave, Raymore, MO 64083, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "People say this warehouse club offers a wide variety of products, including auto tires. They also highlight the reasonable prices and reliable service.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7912-0bc5-7091-ba85-53f6d89e4395.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0bc5-7091-ba85-53f6d89e4395",
        "storage_key": "property/6767906449165590/019d7912-0bc5-7091-ba85-53f6d89e4395.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.samsclub.com/club/8243-raymore-mo",
      "poi_directions_map_url": "https://maps.google.com/?cid=7262250417114567002&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sam-s-club",
      "poi_latitude": "38.8090996",
      "poi_longitude": "-94.4912943",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-765-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4419d93ea347.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4419d93ea347",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4419d93ea347.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJb8Hg7H3dwIcRWtEL_kayyGQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_8acea0ab-ee6c-41df-b838-6c4dc2df368c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Shopping & Retail",
      "poi_address": "551 Markey Pkwy, Belton, MO 64012, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "People say this cosmetics store offers a wide selection of products, including makeup, skincare, and haircare. They highlight the helpful staff and the availability of different brands and price points. They also like the clean and organized store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-047e-74e6-ac1e-73dca2c31763.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-047e-74e6-ac1e-73dca2c31763",
        "storage_key": "property/6767906449165590/019cfb3b-047e-74e6-ac1e-73dca2c31763.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/belton-mo-1496",
      "poi_directions_map_url": "https://maps.google.com/?cid=11810489918034091263&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "38.8225625",
      "poi_longitude": "-94.5274435",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-348-3087",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4419d93ea347.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4419d93ea347",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4419d93ea347.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJt0pjxzLdwIcR_xzBewFK56M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cosmetics_store"
    },
    {
      "id": "custom_239c2a30-3f08-48ad-857b-fa2630469d99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "531 Markey Pkwy, Belton, MO 64012, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7912-0fc2-746a-83db-773497aef738.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0fc2-746a-83db-773497aef738",
        "storage_key": "property/6767906449165590/019d7912-0fc2-746a-83db-773497aef738.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10660839891060688856&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "38.823664",
      "poi_longitude": "-94.5261063",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-318-9605",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4419d93ea347.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4419d93ea347",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4419d93ea347.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJR9r9IH3dwIcR2If8uWXp8pM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_1fd48be0-baa4-4395-a123-92cc5fa1c8fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Cleveland Lake Disc Golf Course",
      "poi_type": "Entertainment",
      "poi_address": "503 S Cleveland Ave, Belton, MO 64012, USA",
      "poi_short_description": "Wooded and open-grass disc golf course with concrete tee pads and multiple tee locations.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7912-1231-7409-a1f9-d125f9bddb4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1231-7409-a1f9-d125f9bddb4d",
        "storage_key": "property/6767906449165590/019d7912-1231-7409-a1f9-d125f9bddb4d.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11466011395691075455&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cleveland-lake-disc-golf-course",
      "poi_latitude": "38.8080145",
      "poi_longitude": "-94.5496675",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4a0cdc830ed6",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR9w8v2XbwIcRf1e_Zp10H58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_8d45dd4b-79d4-4526-b37a-2004f6bf93fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Aaron's Family Fun Center",
      "poi_type": "Entertainment",
      "poi_address": "17070 Aaron Ln, Belton, MO 64012, USA",
      "poi_short_description": "Mini-golf, sand volleyball & bowling, plus a private 6-lane alley available for parties.",
      "poi_long_description": "Mini-golf, sand volleyball & bowling, plus a private 6-lane alley available for parties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7912-1444-70fe-8d82-0d43f7d35bac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1444-70fe-8d82-0d43f7d35bac",
        "storage_key": "property/6767906449165590/019d7912-1444-70fe-8d82-0d43f7d35bac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://aaronsfec.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15444066182043561025&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "aaron-s-family-fun-center",
      "poi_latitude": "38.8151009",
      "poi_longitude": "-94.5008071",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-322-0488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4a0cdc830ed6",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVeSq0PTbwIcRQWxUzF1YVNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_4d05ada8-b026-4935-8017-10282b7474dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Raymore Recreation Park",
      "poi_type": "Entertainment",
      "poi_address": "Raymore, MO 64083, USA",
      "poi_short_description": "Park with picnic and play areas, plus a pond, skateboarding area, athletic fields, and disc golf.",
      "poi_long_description": "Visitors say this park has a well-maintained playground with swings and other equipment for kids of all ages, and they also highlight the park's tennis courts, baseball fields, and basketball courts. They like that the park is safe and a great place for families to enjoy outdoor activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7912-13cf-70b6-b145-78fad239dbd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-13cf-70b6-b145-78fad239dbd2",
        "storage_key": "property/6767906449165590/019d7912-13cf-70b6-b145-78fad239dbd2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.raymore.com/government/city-departments/parks-recreation/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=4941482516900123600&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "raymore-recreation-park",
      "poi_latitude": "38.7876577",
      "poi_longitude": "-94.4533622",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-322-2791",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-15d9-7319-881b-0a4e4f1e01e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-15d9-7319-881b-0a4e4f1e01e6",
        "storage_key": "property/6767906449165590/019cfb3b-15d9-7319-881b-0a4e4f1e01e6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJowtmEQ7ZwIcR0JOiAyusk0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_79130d8b-1ebf-4bec-8bd4-860737cdcadd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "The Regnier Family Wonderscope Children's Museum of Kansas City",
      "poi_type": "Entertainment",
      "poi_address": "433 E Red Bridge Rd, Kansas City, MO 64131, USA",
      "poi_short_description": "Museum featuring hands-on exhibits about art, science, math & reading designed for kids.",
      "poi_long_description": "People say this children's museum offers a wide variety of interactive exhibits, hands-on activities, and engaging learning experiences, including a water table, creation station, science lab, and market/restaurant. They also highlight the clean, safe, and thoughtfully designed facility, as well as the friendly and attentive staff.\n\nSome reviews mention the space can be messy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7912-16d4-73fa-ba3e-75fe6bf7a407.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-16d4-73fa-ba3e-75fe6bf7a407",
        "storage_key": "property/6767906449165590/019d7912-16d4-73fa-ba3e-75fe6bf7a407.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.wonderscope.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6568020706734645777&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-regnier-family-wonderscope-children-s-museum-of-kansas-city",
      "poi_latitude": "38.92533170000001",
      "poi_longitude": "-94.58748210000002",
      "poi_miles_from_property": "11.8 mi",
      "poi_walking_minutes": "4 hours 17 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 816-643-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-130c-7756-804c-0d16ebef24cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-130c-7756-804c-0d16ebef24cc",
        "storage_key": "property/6767906449165590/019cfb3b-130c-7756-804c-0d16ebef24cc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgeXMgi_twIcRESJUrghMJls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d2a7ab15-1ff1-4cdc-ba3d-4dfafb5fc500",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Kansas City Zoo & Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "6800 Zoo Dr, Kansas City, MO 64132, USA",
      "poi_short_description": "Zoo in Swope Park with zookeepers offering animal interaction & informative chats.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including penguins, polar bears, and elephants, and features a beautiful aquarium with sharks and stingrays. They highlight the spacious, natural habitats, the fun rides like the train and tram, and the interactive experiences such as the petting zoo and animal encounters. They also like the friendly and helpful staff, and the clean, well-maintained facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d7912-1886-70a2-8df9-e47dae0cf4df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1886-70a2-8df9-e47dae0cf4df",
        "storage_key": "property/6767906449165590/019d7912-1886-70a2-8df9-e47dae0cf4df.webp",
        "width": 680,
        "height": 473
      },
      "poi_business_url": "https://www.kansascityzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12992684715297648381&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kansas-city-zoo-aquarium",
      "poi_latitude": "39.0072568",
      "poi_longitude": "-94.5293443",
      "poi_miles_from_property": "17.0 mi",
      "poi_walking_minutes": "6 hours 13 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 816-595-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1302-71af-9c30-4a0cdc830ed6",
        "storage_key": "property/6767906449165590/019cfb3b-1302-71af-9c30-4a0cdc830ed6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAaCDFcrlwIcR_a72DelJT7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_b3c9033f-843d-49fa-8d26-a56e1c883e12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "Heartland High School and Academy (grades pre-K through 12)",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "heartland-high-school-and-academy-grades-pre-k-through-12",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_151519a3-6d18-4ef6-837f-35d200a39a8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "poi_name": "JOANN Fabric & Crafts",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "joann-fabric-crafts",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_cb4a27e98dd7354e4c8815a3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_b9549ea91e01486826970df3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_7888539a693b17d56f3f1497",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_8a788e1adbdabfce623d5f13",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_2d28b7304b46a01c29f03bce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [],
  "virtual_tours": [
    {
      "id": "custom_daad0e1c-4628-435e-952b-2712e382bee0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3b-bd76-71fe-8469-f6870ece509b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of apartment building lobby and amenities with fireplace and seating area.",
        "public_id": "019cfb3b-bd76-71fe-8469-f6870ece509b",
        "storage_key": "property/6767906449165590/019cfb3b-bd76-71fe-8469-f6870ece509b.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Center 301 Apartments Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=64812dd302d5955b3afae808"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a03b3-2560-720d-ba3f-420c444bcdc9",
      "lead_source": "LANDING_PAGE",
      "name": "case-center-301-lp",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590"
    },
    {
      "lead_collector_id": "019cf79d-362e-7668-bf1e-30aa27825d11",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "center-301",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "generator",
      "page_item_url": "apartments-with-pool-belton-mo",
      "search_query": "apartments with pool in Belton MO",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Belton, MO",
      "h2_subtitle": "Discover your dream apartment with a pool in Belton, MO. Enjoy modern amenities and a relaxing lifestyle at Center 301.",
      "page_copy": "Welcome to Center 301, where your search for perfect apartments with a pool in Belton, MO ends! Our beautiful community offers stunning one- and two-bedroom floor plans designed for modern comfort. Imagine relaxing by our pristine pool or enjoying a walk on our scenic walking trails. We provide a rich array of amenities including ceiling fans and Wi-Fi, making sure you experience nothing short of excellence in apartment living.\n\nNestled in the heart of Belton, Center 301 not only offers a refreshing pool but also convenient access to local attractions. With a pet-friendly environment and a vibrant clubhouse, our community caters to your lifestyle. Whether you are enjoying our breakfast/coffee concierge or the convenience of online services, life here is crafted to offer joy and relaxation. Visit us today and see why living here feels like a dream!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for Center Apartments 301 with landscaping and buildings in the background.",
        "public_id": "019cfb3a-c92d-767d-b354-5da6879c86c4",
        "storage_key": "property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
        "width": 500,
        "height": 333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Belton, MO",
      "seo_description": "Find apartments with a pool in Belton, MO at Center 301 with modern amenities and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-park-belton-mo",
      "search_query": "pet friendly apartments with dog park Belton MO",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park",
      "h2_subtitle": "Explore pet-friendly apartments with a dog park in Belton, MO. Center 301 offers a welcoming haven for you and your furry friends.",
      "page_copy": "At Center 301, our pet-friendly apartments with a dog park in Belton, MO are designed with your furry friends in mind. Discover spacious one- and two-bedroom units that cater not only to your needs but also the needs of your pets. Enjoy bonding with your pets at our very own dog park, while relishing life in a lively and scenic environment. With amenities like ceiling fans, Wi-Fi, and online services, living with pets is both convenient and joyful.\n\nLocated in the vibrant city of Belton, Center 301 ensures much more than just a comfortable stay. Our community offers pet-friendly spaces along with a vibrant clubhouse and convenient breakfast/coffee concierge. The extensive walking trails provide a perfect backdrop for you and your pet’s daily strolls. Experience the balance between modern living and pet care, and make Center 301 your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for Center Apartments 301 with landscaping and buildings in the background.",
        "public_id": "019cfb3a-c92d-767d-b354-5da6879c86c4",
        "storage_key": "property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
        "width": 500,
        "height": 333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Park",
      "seo_description": "Find pet-friendly apartments with a dog park in Belton, MO at Center 301. Perfect for you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "generator",
      "page_item_url": "luxury-apartments-walk-in-closets-belton-mo",
      "search_query": "luxury apartments with walk-in closets Belton Missouri",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Walk-In Closets",
      "h2_subtitle": "Discover luxury apartments with walk-in closets in Belton, Missouri. Enjoy modern amenities and a lavish lifestyle at Center 301.",
      "page_copy": "Experience the epitome of opulence at Center 301, offering luxury apartments with walk-in closets in Belton, Missouri. Our chic one- and two-bedroom layouts are designed to meet the high standards of modern living. Every apartment features spacious interiors, making them a perfect retreat after a busy day. With amenities such as a refreshing pool, ceiling fans, and high-speed Wi-Fi, your comfort is our priority.\n\nBeyond the extravagant interiors, our community in Belton provides top-tier services including a breakfast/coffee concierge and online conveniences. Nestled in a vibrant neighborhood, Center 301 is surrounded by picturesque walking trails, making it an ideal setting for both relaxation and excitement. Step into a world of luxury and make Center 301 your home today, where spacious walk-in closets meet refined living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for Center Apartments 301 with landscaping and buildings in the background.",
        "public_id": "019cfb3a-c92d-767d-b354-5da6879c86c4",
        "storage_key": "property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
        "width": 500,
        "height": 333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Walk-In Closets",
      "seo_description": "Find luxury apartments with walk-in closets in Belton, MO at Center 301 and enjoy modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "generator",
      "page_item_url": "apartments-with-fitness-center-belton-64012",
      "search_query": "apartments with fitness center Belton 64012",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Belton",
      "h2_subtitle": "Discover modern apartments with a fitness center in Belton, 64012. Center 301 offers the perfect blend of comfort and convenience.",
      "page_copy": "Welcome to Center 301, where you can find apartments with a fitness center in Belton, 64012. Our community embraces a healthy lifestyle with spacious one- and two-bedroom floor plans that provide the ultimate in comfort and convenience. Enjoy an invigorating workout in our state-of-the-art fitness center, perfectly complementing other amenities like our refreshing pool and vibrant clubhouse.\n\nLocated in the heart of Belton, Center 301 offers more than just fitness amenities. With pet-friendly options, ceiling fans, and high-speed Wi-Fi, you'll find everything you need to live comfortably. Complement your active lifestyle with scenic walking trails nearby, or take advantage of our breakfast/coffee concierge and online services. Discover the ideal balance of modern living and fitness perks, all at Center 301.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for Center Apartments 301 with landscaping and buildings in the background.",
        "public_id": "019cfb3a-c92d-767d-b354-5da6879c86c4",
        "storage_key": "property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
        "width": 500,
        "height": 333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in Belton",
      "seo_description": "Discover apartments with a fitness center in Belton, MO 64012 at Center 301, offering comfort and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "generator",
      "page_item_url": "belton-mo-apartments-air-conditioning",
      "search_query": "Belton MO apartments with air conditioning",
      "category": "Amenity",
      "h1_title": "Belton MO Apartments with Air Conditioning",
      "h2_subtitle": "Find apartments with air conditioning in Belton, MO. At Center 301, comfort meets modern living with top-tier amenities.",
      "page_copy": "Stay cool and comfortable at Center 301, where our Belton, MO apartments with air conditioning offer you the perfect home environment. Our thoughtfully designed one- and two-bedroom floor plans provide not only climate control but also an array of modern amenities such as a vibrant clubhouse and pet-friendly spaces. Air conditioning ensures that you can relax in comfort regardless of the weather outside.\n\nLocated in lively Belton, Center 301 is home to more than just cooling comfort. Enjoy additional conveniences like high-speed Wi-Fi, online services, and a breakfast/coffee concierge to make daily living easier. Explore the scenic walking trails and discover how Center 301 integrates the luxuries of modern life with the tranquility of nature. Make your new home with us and enjoy unparalleled comfort all year round.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for Center Apartments 301 with landscaping and buildings in the background.",
        "public_id": "019cfb3a-c92d-767d-b354-5da6879c86c4",
        "storage_key": "property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
        "width": 500,
        "height": 333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Belton MO Apartments with Air Conditioning",
      "seo_description": "Find comfortable apartments with air conditioning in Belton, MO at Center 301, featuring modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-belton-mo",
      "search_query": "one bedroom apartments Belton MO",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Belton MO",
      "h2_subtitle": "Explore one bedroom apartments in Belton, MO, at Center 301. Experience comfortable living with modern amenities tailored for you.",
      "page_copy": "Discover the ideal blend of comfort and convenience with our one bedroom apartments in Belton, MO, at Center 301. Each apartment is thoughtfully designed, providing a spacious retreat equipped with amenities like air conditioning and high-speed Wi-Fi, perfect for modern living. Delight in a refreshing pool and vibrant clubhouse, making relaxation and entertainment a daily pleasure.\n\nLocated in a bustling community, Center 301 is just steps away from local attractions and scenic walking trails, enabling you to enjoy both comfort indoors and adventure outdoors. Our pet-friendly spaces and dedicated breakfast/coffee concierge ensure that daily living is enjoyable and stress-free. Experience the unique charm of Belton, Missouri, and find your dream home at Center 301 today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for Center Apartments 301 with landscaping and buildings in the background.",
        "public_id": "019cfb3a-c92d-767d-b354-5da6879c86c4",
        "storage_key": "property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
        "width": 500,
        "height": 333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Belton MO",
      "seo_description": "Explore spacious one bedroom apartments in Belton, MO at Center 301, offering modern conveniences and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-64012",
      "search_query": "two bedroom apartments near 64012",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 64012",
      "h2_subtitle": "Discover spacious two bedroom apartments near 64012 at Center 301. Experience modern living with exceptional amenities in Belton.",
      "page_copy": "Welcome to Center 301, where you can find the perfect two bedroom apartments near 64012. Our thoughtfully designed residences provide ample living space and are equipped with high-end amenities like air conditioning, Wi-Fi, and ceiling fans, ensuring a comfortable lifestyle. Enjoy the luxury of a refreshing pool and a lively clubhouse, perfect for hosting gatherings or relaxing after a busy day.\n\nLocated in the charming community of Belton, Center 301 offers more than just modern interiors. Our pet-friendly setting boasts scenic walking trails and convenient access to local attractions, making it a vibrant place to call home. Complement your active lifestyle with our breakfast/coffee concierge and online services. Experience the ultimate in two-bedroom living today at Center 301.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for Center Apartments 301 with landscaping and buildings in the background.",
        "public_id": "019cfb3a-c92d-767d-b354-5da6879c86c4",
        "storage_key": "property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
        "width": 500,
        "height": 333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 64012",
      "seo_description": "Discover spacious two bedroom apartments near 64012 at Center 301, complete with modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "generator",
      "page_item_url": "apartments-near-calvary-university-belton-mo",
      "search_query": "apartments near calvary university belton mo",
      "category": "School",
      "h1_title": "Apartments Near Calvary University Belton MO",
      "h2_subtitle": "Find ideal apartments near Calvary University in Belton, MO at Center 301. Enjoy a convenient and comfortable lifestyle close to campus.",
      "page_copy": "For students, faculty, and staff seeking convenient living, discover ideal apartments near Calvary University in Belton, MO at Center 301. Offering modern amenities like Wi-Fi, air conditioning, and ceiling fans, these spacious one- and two-bedroom layouts provide comfort and convenience to support any academic lifestyle. After a long day on campus, unwind by the refreshing pool or meet friends in the vibrant clubhouse.\n\nLocated just a short drive away from Calvary University, Center 301 offers more than just proximity to the academic hub. Benefit from pet-friendly spaces and scenic walking trails that make leisure and recreation part of everyday life. With a breakfast/coffee concierge and convenient online services, you can focus on your studies knowing you're living in a place designed for both ease and relaxation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for Center Apartments 301 with landscaping and buildings in the background.",
        "public_id": "019cfb3a-c92d-767d-b354-5da6879c86c4",
        "storage_key": "property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
        "width": 500,
        "height": 333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Calvary University Belton MO",
      "seo_description": "Find convenient apartments near Calvary University in Belton, MO at Center 301, offering modern amenities and a comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "generator",
      "page_item_url": "apartments-near-belton-regional-medical-center",
      "search_query": "apartments near Belton Regional Medical Center",
      "category": "Hospital",
      "h1_title": "Apartments Near Belton Regional Medical Center",
      "h2_subtitle": "Discover ideal apartments near Belton Regional Medical Center at Center 301. Experience comfortable living close to healthcare facilities.",
      "page_copy": "For healthcare professionals and patients seeking convenient living, explore apartments near Belton Regional Medical Center at Center 301. Our spacious one- and two-bedroom apartments come with essential amenities like air conditioning, Wi-Fi, and a dishwasher—ensuring a comfortable living experience. Enjoy the convenience of a refreshing pool and a lively clubhouse, perfect for relaxation after a demanding workday or treatment.\n\nSituated just moments away from Belton Regional Medical Center, Center 301 offers both proximity and peace. The pet-friendly environment and scenic walking trails are ideal for leisure activities and stress relief. With a breakfast/coffee concierge and efficient online services, daily routines become simple and hassle-free. Find your perfect home at Center 301, where convenience meets modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for Center Apartments 301 with landscaping and buildings in the background.",
        "public_id": "019cfb3a-c92d-767d-b354-5da6879c86c4",
        "storage_key": "property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
        "width": 500,
        "height": 333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Belton Regional Medical Center",
      "seo_description": "Explore comfortable apartments near Belton Regional Medical Center at Center 301, offering modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "generator",
      "page_item_url": "apartments-near-markey-park-belton",
      "search_query": "apartments near markey park belton",
      "category": "Park",
      "h1_title": "Apartments Near Markey Park Belton",
      "h2_subtitle": "Find perfect apartments near Markey Park in Belton at Center 301. Enjoy vibrant living with outdoor spaces just steps away.",
      "page_copy": "Looking for luxurious apartments near Markey Park in Belton? Center 301 offers spacious one- and two-bedroom apartments tailored to your modern lifestyle, complete with cutting-edge amenities like Wi-Fi, ceiling fans, and a convenient dishwasher. For those who love the outdoors, our proximity to Markey Park means that scenic walking trails and abundant green spaces are just a few moments away.\n\nCenter 301 is more than just a place to live—it's a community where residents can enjoy pet-friendly surroundings and a vibrant clubhouse perfect for social gatherings or quiet reflection. Start your day with our breakfast/coffee concierge or take advantage of our online services to simplify your daily tasks. Discover a lifestyle of comfort and convenience at Center 301, close to the natural beauty of Markey Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for Center Apartments 301 with landscaping and buildings in the background.",
        "public_id": "019cfb3a-c92d-767d-b354-5da6879c86c4",
        "storage_key": "property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
        "width": 500,
        "height": 333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Markey Park Belton",
      "seo_description": "Discover spacious apartments near Markey Park in Belton at Center 301, offering modern amenities and a lively community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "generator",
      "page_item_url": "living-close-to-hawk-ridge-park-mo",
      "search_query": "living close to hawk ridge park mo",
      "category": "Park",
      "h1_title": "Living Close to Hawk Ridge Park MO",
      "h2_subtitle": "Experience the perks of living close to Hawk Ridge Park, MO. Center 301 offers the ideal balance of outdoor beauty and modern amenities.",
      "page_copy": "Imagine living close to Hawk Ridge Park, MO, where the beauty of nature is just a short stroll away. At Center 301, you will find spacious one- and two-bedroom apartments equipped with top-of-the-line amenities like Wi-Fi, ceiling fans, and a dishwasher. This prime location allows you easy access to the stunning landscapes and recreational activities of Hawk Ridge Park.\n\nResidents of Center 301 enjoy more than proximity to natural beauty. The community boasts a vibrant clubhouse and a refreshing pool, perfect for relaxation after outdoor activities. Our pet-friendly spaces and scenic walking trails enhance the neighborhood's appeal, while a breakfast/coffee concierge and seamless online services ensure convenience. Live the dream lifestyle at Center 301, where nature and modern living blend seamlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for Center Apartments 301 with landscaping and buildings in the background.",
        "public_id": "019cfb3a-c92d-767d-b354-5da6879c86c4",
        "storage_key": "property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
        "width": 500,
        "height": 333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to Hawk Ridge Park MO",
      "seo_description": "Enjoy modern living close to Hawk Ridge Park, MO at Center 301. Discover spacious apartments with a blend of convenience and nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165590",
      "source": "generator",
      "page_item_url": "find-homes-by-meadowmere-park-64012",
      "search_query": "find homes by meadowmere park 64012",
      "category": "Park",
      "h1_title": "Find Homes by Meadowmere Park 64012",
      "h2_subtitle": "Discover your ideal home by Meadowmere Park, 64012. Center 301 offers comfort and proximity to nature's beauty.",
      "page_copy": "Searching to find homes by Meadowmere Park, 64012? Look no further than Center 301, where our spacious one- and two-bedroom apartments offer you the perfect blend of comfort and convenience. Equipped with must-have amenities like Wi-Fi, ceiling fans, and a dishwasher, our spaces are designed to cater to your modern lifestyle, while being just steps away from the scenic beauty of Meadowmere Park.\n\nAt Center 301, you'll discover a lifestyle enriched by community features including a vibrant clubhouse and a refreshing pool ideal for unwinding after a day spent at Meadowmere Park. Our pet-friendly environment and scenic walking trails enhance your living experience, while a breakfast/coffee concierge and efficient online services simplify daily tasks. Live in a prime location that brings you closer to nature and modern comforts at Center 301.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
      "featured_image_media": {
        "alt_text": "Monument sign for Center Apartments 301 with landscaping and buildings in the background.",
        "public_id": "019cfb3a-c92d-767d-b354-5da6879c86c4",
        "storage_key": "property/6767906449165590/019cfb3a-c92d-767d-b354-5da6879c86c4.webp",
        "width": 500,
        "height": 333
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Find Homes by Meadowmere Park 64012",
      "seo_description": "Find your dream home by Meadowmere Park, 64012 at Center 301. Enjoy modern amenities and a perfect location near nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5153"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-WLP6KJDJEK"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18128851078"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/center-301/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TKG6FTDP"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165590/019d1bd7-4975-7117-8586-7c98a143152f.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "e6aba152-82e4-4da6-9965-46ce7d99ca54"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "800-645-8415"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6435a7cec5b15811e710f1ea"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImhiRlkvSXA3NzZQUkMwMDJFWVZKZHc9PSIsInZhbHVlIjoiTGxWd0U1WXpQV2EzSW1yb3huMmFhUT09IiwibWFjIjoiNDE2MTYzYjg4NzBkNTEzNzY0YzdjNzM3NTViZGJiMTNmZmYzMzFjNjA1YTg4MjZhYzc1MzJkYzcyNzZmMjMzNyJ9"
    }
  ],
  "custom_qb_id": "5153",
  "custom_ga4_id": "G-WLP6KJDJEK",
  "custom_repli_id": "18128851078",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/center-301/register/",
  "custom_google_gtm_id": "GTM-TKG6FTDP",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165590/019d1bd7-4975-7117-8586-7c98a143152f.pdf",
  "custom_rentgrata_property_id": "e6aba152-82e4-4da6-9965-46ce7d99ca54",
  "custom_ppc_tracking_phone_number": "800-645-8415",
  "custom_residentboost_apartment_id": "6435a7cec5b15811e710f1ea",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImhiRlkvSXA3NzZQUkMwMDJFWVZKZHc9PSIsInZhbHVlIjoiTGxWd0U1WXpQV2EzSW1yb3huMmFhUT09IiwibWFjIjoiNDE2MTYzYjg4NzBkNTEzNzY0YzdjNzM3NTViZGJiMTNmZmYzMzFjNjA1YTg4MjZhYzc1MzJkYzcyNzZmMjMzNyJ9"
};

export const generatedAt = '2026-08-27T21:39:15.824Z';
